const navIconSize = {
  height: "20px",
  width: "20px",
};
const navIconWhite = {
  fill: "#fff",
  ...navIconSize,
};
const navIconPurple = {
  fill: "#4B5781",
  ...navIconSize,
};

export const navBarIcons = {
  Breakfast: {
    iconWhite: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 63.62 53.6"
        style={{ ...navIconWhite }}
      >
        <defs></defs>
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_3" data-name="Layer 3">
            <path d="M12.75,22.6H51.34A2.41,2.41,0,0,1,53.75,25v7.05A17.34,17.34,0,0,1,36.41,49.4H27.69A17.34,17.34,0,0,1,10.34,32.06V25A2.41,2.41,0,0,1,12.75,22.6Z" />
            <path d="M53.74,26.8c-5,0-9,3.11-9,7s4,7,9,7,9-3.13,9-7S58.73,26.8,53.74,26.8Zm0,10.92c-2.83,0-5.12-1.77-5.12-4s2.29-3.94,5.12-3.94,5.12,1.77,5.12,3.94S56.57,37.72,53.74,37.72Z" />
            <rect y="48.61" width="63.62" height="4.99" rx="1.95" />
            <path
              className="cls-1"
              d="M23.27,1.58c-1.83,3-1.76,5-1.36,6.18.64,2,2.26,2.45,2.71,4.37S24,16.08,23,17.41"
            />
            <path
              className="cls-1"
              d="M32.11,1.58c-1.83,3-1.76,5-1.36,6.18.64,2,2.26,2.45,2.71,4.37s-.65,3.95-1.66,5.28"
            />
            <path
              className="cls-1"
              d="M40.23,1.58c-1.82,3-1.76,5-1.36,6.18.64,2,2.26,2.45,2.72,4.37s-.66,3.95-1.66,5.28"
            />
          </g>
        </g>
      </svg>
    ),
    iconPurple: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 63.62 53.6"
        style={{ ...navIconPurple }}
      >
        <defs></defs>
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_3" data-name="Layer 3">
            <path d="M12.75,22.6H51.34A2.41,2.41,0,0,1,53.75,25v7.05A17.34,17.34,0,0,1,36.41,49.4H27.69A17.34,17.34,0,0,1,10.34,32.06V25A2.41,2.41,0,0,1,12.75,22.6Z" />
            <path d="M53.74,26.8c-5,0-9,3.11-9,7s4,7,9,7,9-3.13,9-7S58.73,26.8,53.74,26.8Zm0,10.92c-2.83,0-5.12-1.77-5.12-4s2.29-3.94,5.12-3.94,5.12,1.77,5.12,3.94S56.57,37.72,53.74,37.72Z" />
            <rect y="48.61" width="63.62" height="4.99" rx="1.95" />
            <path
              className="cls-1"
              d="M23.27,1.58c-1.83,3-1.76,5-1.36,6.18.64,2,2.26,2.45,2.71,4.37S24,16.08,23,17.41"
            />
            <path
              className="cls-1"
              d="M32.11,1.58c-1.83,3-1.76,5-1.36,6.18.64,2,2.26,2.45,2.71,4.37s-.65,3.95-1.66,5.28"
            />
            <path
              className="cls-1"
              d="M40.23,1.58c-1.82,3-1.76,5-1.36,6.18.64,2,2.26,2.45,2.72,4.37s-.66,3.95-1.66,5.28"
            />
          </g>
        </g>
      </svg>
    ),
  },
  Dinner: {
    iconWhite: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 31.12 55.61"
        style={{ ...navIconWhite }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <path d="M5,22.53c0,1.47.36,22.09.41,29.11A3.76,3.76,0,0,0,7,54.74a3.45,3.45,0,0,0,3.87-.18,3.72,3.72,0,0,0,1.39-2.91L11.07,22.52a5,5,0,0,0,4.08-3.91C15.05,13.3,15,8,14.85,2.67A1.82,1.82,0,0,0,14,1,1.2,1.2,0,0,0,12.78.92a1.66,1.66,0,0,0-.92,1.56l.23,12.27a1.59,1.59,0,0,1-1,.92,1.63,1.63,0,0,1-1.77-1.23c-.11-4-.2-7.61-.31-11.59C9,2.69,9,1.47,8,1.18a1.36,1.36,0,0,0-1.18.09A1.94,1.94,0,0,0,6,3l.28,11.3A1.56,1.56,0,0,1,5.19,15.7a1.65,1.65,0,0,1-1.88-1.43L3,3.2a2,2,0,0,0-.64-1.41c-.62-.55-1.08-.68-1.78.05A2,2,0,0,0,0,3.37Q.12,10.69.23,18a5,5,0,0,0,1.45,3.13A5.06,5.06,0,0,0,5,22.53Z" />
            <path d="M19.72,1.36q.41,25.11.8,50.23c0,1.6.08,2.44.95,3.23a3.36,3.36,0,0,0,3.81.37,3.61,3.61,0,0,0,1.84-3.62l-.9-22.95a2.1,2.1,0,0,1,1.64-2.12,4.23,4.23,0,0,0,1.61-.75A4,4,0,0,0,31,23.58a3.36,3.36,0,0,0,.1-.68,58.92,58.92,0,0,0-.85-9.07c-.93-5.41-2.13-7.72-2.9-9A12.79,12.79,0,0,0,23.16.74c-1.72-1-2.4-.75-2.68-.59A1.81,1.81,0,0,0,19.72,1.36Z" />
          </g>
        </g>
      </svg>
    ),
    iconPurple: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 31.12 55.61"
        style={{ ...navIconPurple }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <path d="M5,22.53c0,1.47.36,22.09.41,29.11A3.76,3.76,0,0,0,7,54.74a3.45,3.45,0,0,0,3.87-.18,3.72,3.72,0,0,0,1.39-2.91L11.07,22.52a5,5,0,0,0,4.08-3.91C15.05,13.3,15,8,14.85,2.67A1.82,1.82,0,0,0,14,1,1.2,1.2,0,0,0,12.78.92a1.66,1.66,0,0,0-.92,1.56l.23,12.27a1.59,1.59,0,0,1-1,.92,1.63,1.63,0,0,1-1.77-1.23c-.11-4-.2-7.61-.31-11.59C9,2.69,9,1.47,8,1.18a1.36,1.36,0,0,0-1.18.09A1.94,1.94,0,0,0,6,3l.28,11.3A1.56,1.56,0,0,1,5.19,15.7a1.65,1.65,0,0,1-1.88-1.43L3,3.2a2,2,0,0,0-.64-1.41c-.62-.55-1.08-.68-1.78.05A2,2,0,0,0,0,3.37Q.12,10.69.23,18a5,5,0,0,0,1.45,3.13A5.06,5.06,0,0,0,5,22.53Z" />
            <path d="M19.72,1.36q.41,25.11.8,50.23c0,1.6.08,2.44.95,3.23a3.36,3.36,0,0,0,3.81.37,3.61,3.61,0,0,0,1.84-3.62l-.9-22.95a2.1,2.1,0,0,1,1.64-2.12,4.23,4.23,0,0,0,1.61-.75A4,4,0,0,0,31,23.58a3.36,3.36,0,0,0,.1-.68,58.92,58.92,0,0,0-.85-9.07c-.93-5.41-2.13-7.72-2.9-9A12.79,12.79,0,0,0,23.16.74c-1.72-1-2.4-.75-2.68-.59A1.81,1.81,0,0,0,19.72,1.36Z" />
          </g>
        </g>
      </svg>
    ),
  },
  Dining: {
    iconWhite: (
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="388.331px"
        height="388.33px"
        viewBox="0 0 388.331 388.33"
        style={{ ...navIconWhite }}
      >
        <g>
          <path
            d="M264.07,166.541c21.39,11.462,62.59,7.953,93.913-23.377c31.068-31.062,42.815-76.485,13.442-106.828l0.023-0.012
     c-0.139-0.128-0.639-0.627-0.767-0.761c0,0,0,0.012-0.023,0.012c-30.324-29.36-75.742-17.62-106.821,13.443
     c-31.324,31.33-34.833,72.53-23.377,93.919c-2.951,17.515-26.979,36.518-48.531,48.851c-16.621-10.253-37.581-28.373-39.783-64.803
     c1.592-14.552-3.201-29.674-14.337-40.811c-1.022-1.022-3.962-3.509-3.962-3.509L52.656,19.431l-7.396,7.39l88.099,82.649
     l-9.556,9.556L38.452,33.669L30.615,41.5l85.339,85.362l-8.069,8.069L22.546,49.593l-7.14,7.076l84.828,84.834l-9.719,9.754
     L8.092,64L0,72.116l67.376,84.897c0,0,1.604,1.644,2.283,2.248c9.806,8.569,22.116,12.612,34.298,12.27
     c0.087,0,0.215,0.023,0.261,0.035c32.079,0.32,51.901,19.822,64.368,36.646C138.082,238.733,43.413,333.413,43.413,333.413
     l0.023,0.023c-0.093,0.07-0.215,0.151-0.308,0.244c-7.709,7.703-7.709,20.205,0,27.932c0.395,0.383,1.882,1.859,2.26,2.254
     c7.709,7.715,20.229,7.715,27.926,0.012c0.093-0.093,0.174-0.209,0.25-0.313l0.023,0.034c0,0,87.913-87.918,121.619-121.612
     c32.079,32.067,120.997,120.962,120.997,120.962l0.023-0.023c0.069,0.082,0.104,0.197,0.221,0.314
     c7.575,7.563,19.938,7.563,27.524-0.023c7.587-7.599,7.61-19.914,0.011-27.525c-0.115-0.104-0.231-0.139-0.324-0.243l0.022-0.023
     c0,0-98.212-98.201-125.458-125.47C230.526,189.9,247.931,169.259,264.07,166.541z M253.636,107.878
     c0.464-5.211,1.51-11.206,3.241-17.55c0.918-3.154,1.998-6.402,3.312-9.684c1.452-3.334,2.975-6.437,5.205-9.684
     c4.264-6.233,9.457-11.079,14.628-15.145c5.112-4.119,10.306-7.32,14.918-9.748c4.578-2.475,8.679-4.078,11.607-4.996
     c2.974-0.976,4.705-1.104,4.705-1.104s-1.429,1.081-3.566,3.079c-2.161,2.01-5.24,4.892-8.946,8.342
     c-7.111,6.937-17.242,15.941-24.423,25.735c-1.731,2.237-3.276,5.188-4.624,7.889c-1.464,2.76-2.766,5.612-3.95,8.435
     c-2.464,5.612-4.497,11.049-6.251,15.738c-1.708,4.7-3.044,8.673-3.834,11.497c-0.86,2.829-0.744,4.508-0.604,4.508
     c-0.069,0.105-1.127-1.522-1.44-4.642C253.229,117.463,253.148,113.077,253.636,107.878z"
          />
        </g>
      </svg>
    ),
    iconPurple: (
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="388.331px"
        height="388.33px"
        viewBox="0 0 388.331 388.33"
        style={{ ...navIconPurple }}
      >
        <g>
          <path
            d="M264.07,166.541c21.39,11.462,62.59,7.953,93.913-23.377c31.068-31.062,42.815-76.485,13.442-106.828l0.023-0.012
     c-0.139-0.128-0.639-0.627-0.767-0.761c0,0,0,0.012-0.023,0.012c-30.324-29.36-75.742-17.62-106.821,13.443
     c-31.324,31.33-34.833,72.53-23.377,93.919c-2.951,17.515-26.979,36.518-48.531,48.851c-16.621-10.253-37.581-28.373-39.783-64.803
     c1.592-14.552-3.201-29.674-14.337-40.811c-1.022-1.022-3.962-3.509-3.962-3.509L52.656,19.431l-7.396,7.39l88.099,82.649
     l-9.556,9.556L38.452,33.669L30.615,41.5l85.339,85.362l-8.069,8.069L22.546,49.593l-7.14,7.076l84.828,84.834l-9.719,9.754
     L8.092,64L0,72.116l67.376,84.897c0,0,1.604,1.644,2.283,2.248c9.806,8.569,22.116,12.612,34.298,12.27
     c0.087,0,0.215,0.023,0.261,0.035c32.079,0.32,51.901,19.822,64.368,36.646C138.082,238.733,43.413,333.413,43.413,333.413
     l0.023,0.023c-0.093,0.07-0.215,0.151-0.308,0.244c-7.709,7.703-7.709,20.205,0,27.932c0.395,0.383,1.882,1.859,2.26,2.254
     c7.709,7.715,20.229,7.715,27.926,0.012c0.093-0.093,0.174-0.209,0.25-0.313l0.023,0.034c0,0,87.913-87.918,121.619-121.612
     c32.079,32.067,120.997,120.962,120.997,120.962l0.023-0.023c0.069,0.082,0.104,0.197,0.221,0.314
     c7.575,7.563,19.938,7.563,27.524-0.023c7.587-7.599,7.61-19.914,0.011-27.525c-0.115-0.104-0.231-0.139-0.324-0.243l0.022-0.023
     c0,0-98.212-98.201-125.458-125.47C230.526,189.9,247.931,169.259,264.07,166.541z M253.636,107.878
     c0.464-5.211,1.51-11.206,3.241-17.55c0.918-3.154,1.998-6.402,3.312-9.684c1.452-3.334,2.975-6.437,5.205-9.684
     c4.264-6.233,9.457-11.079,14.628-15.145c5.112-4.119,10.306-7.32,14.918-9.748c4.578-2.475,8.679-4.078,11.607-4.996
     c2.974-0.976,4.705-1.104,4.705-1.104s-1.429,1.081-3.566,3.079c-2.161,2.01-5.24,4.892-8.946,8.342
     c-7.111,6.937-17.242,15.941-24.423,25.735c-1.731,2.237-3.276,5.188-4.624,7.889c-1.464,2.76-2.766,5.612-3.95,8.435
     c-2.464,5.612-4.497,11.049-6.251,15.738c-1.708,4.7-3.044,8.673-3.834,11.497c-0.86,2.829-0.744,4.508-0.604,4.508
     c-0.069,0.105-1.127-1.522-1.44-4.642C253.229,117.463,253.148,113.077,253.636,107.878z"
          />
        </g>
      </svg>
    ),
  },
  Activities: {
    iconWhite: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 55.21 53.3"
        style={{ ...navIconWhite }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <path d="M37.45,17.06l16.66,3.11a1.34,1.34,0,0,1,.65,2.31L42.15,33.81A1.34,1.34,0,0,0,41.72,35l2.18,16.8a1.33,1.33,0,0,1-2,1.33L27.24,44.62a1.33,1.33,0,0,0-1.24,0L10.69,51.84a1.33,1.33,0,0,1-1.88-1.49l3.54-16.57a1.36,1.36,0,0,0-.34-1.2L.37,20.27A1.34,1.34,0,0,1,1.2,18l16.86-1.75a1.35,1.35,0,0,0,1-.69L27.21.7A1.33,1.33,0,0,1,29.6.79l6.88,15.5A1.34,1.34,0,0,0,37.45,17.06Z" />
          </g>
        </g>
      </svg>
    ),
    iconPurple: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 55.21 53.3"
        style={{ ...navIconPurple }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <path d="M37.45,17.06l16.66,3.11a1.34,1.34,0,0,1,.65,2.31L42.15,33.81A1.34,1.34,0,0,0,41.72,35l2.18,16.8a1.33,1.33,0,0,1-2,1.33L27.24,44.62a1.33,1.33,0,0,0-1.24,0L10.69,51.84a1.33,1.33,0,0,1-1.88-1.49l3.54-16.57a1.36,1.36,0,0,0-.34-1.2L.37,20.27A1.34,1.34,0,0,1,1.2,18l16.86-1.75a1.35,1.35,0,0,0,1-.69L27.21.7A1.33,1.33,0,0,1,29.6.79l6.88,15.5A1.34,1.34,0,0,0,37.45,17.06Z" />
          </g>
        </g>
      </svg>
    ),
  },
  WellnessActivities: {
    iconWhite: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 55.21 53.3"
        style={{ ...navIconWhite }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <path d="M37.45,17.06l16.66,3.11a1.34,1.34,0,0,1,.65,2.31L42.15,33.81A1.34,1.34,0,0,0,41.72,35l2.18,16.8a1.33,1.33,0,0,1-2,1.33L27.24,44.62a1.33,1.33,0,0,0-1.24,0L10.69,51.84a1.33,1.33,0,0,1-1.88-1.49l3.54-16.57a1.36,1.36,0,0,0-.34-1.2L.37,20.27A1.34,1.34,0,0,1,1.2,18l16.86-1.75a1.35,1.35,0,0,0,1-.69L27.21.7A1.33,1.33,0,0,1,29.6.79l6.88,15.5A1.34,1.34,0,0,0,37.45,17.06Z" />
          </g>
        </g>
      </svg>
    ),
    iconPurple: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 55.21 53.3"
        style={{ ...navIconPurple }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <path d="M37.45,17.06l16.66,3.11a1.34,1.34,0,0,1,.65,2.31L42.15,33.81A1.34,1.34,0,0,0,41.72,35l2.18,16.8a1.33,1.33,0,0,1-2,1.33L27.24,44.62a1.33,1.33,0,0,0-1.24,0L10.69,51.84a1.33,1.33,0,0,1-1.88-1.49l3.54-16.57a1.36,1.36,0,0,0-.34-1.2L.37,20.27A1.34,1.34,0,0,1,1.2,18l16.86-1.75a1.35,1.35,0,0,0,1-.69L27.21.7A1.33,1.33,0,0,1,29.6.79l6.88,15.5A1.34,1.34,0,0,0,37.45,17.06Z" />
          </g>
        </g>
      </svg>
    ),
  },
  Spas: {
    iconWhite: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 66.32 51.59"
        style={{ ...navIconWhite }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <path
              id="Icon_awesome-spa"
              data-name="Icon awesome-spa"
              d="M65.43,18.42A36.81,36.81,0,0,0,40.81,28,29.44,29.44,0,0,0,33.16,38.9,29.56,29.56,0,0,0,25.51,28,36.81,36.81,0,0,0,.89,18.42a.88.88,0,0,0-.89.86v0a31.89,31.89,0,0,0,10.22,23,30.56,30.56,0,0,0,22.94,9.31A30.56,30.56,0,0,0,56.1,42.27a31.89,31.89,0,0,0,10.22-23,.88.88,0,0,0-.86-.9ZM33.16,31.15a31.57,31.57,0,0,1,5.08-5.81,34.55,34.55,0,0,1,6.93-5.21A38,38,0,0,0,34,.31a1.38,1.38,0,0,0-1.74,0A38,38,0,0,0,21.15,20.12,33.71,33.71,0,0,1,28,25.24,32.45,32.45,0,0,1,33.16,31.15Z"
            />
          </g>
        </g>
      </svg>
    ),
    iconPurple: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 66.32 51.59"
        style={{ ...navIconPurple }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <path
              id="Icon_awesome-spa"
              data-name="Icon awesome-spa"
              d="M65.43,18.42A36.81,36.81,0,0,0,40.81,28,29.44,29.44,0,0,0,33.16,38.9,29.56,29.56,0,0,0,25.51,28,36.81,36.81,0,0,0,.89,18.42a.88.88,0,0,0-.89.86v0a31.89,31.89,0,0,0,10.22,23,30.56,30.56,0,0,0,22.94,9.31A30.56,30.56,0,0,0,56.1,42.27a31.89,31.89,0,0,0,10.22-23,.88.88,0,0,0-.86-.9ZM33.16,31.15a31.57,31.57,0,0,1,5.08-5.81,34.55,34.55,0,0,1,6.93-5.21A38,38,0,0,0,34,.31a1.38,1.38,0,0,0-1.74,0A38,38,0,0,0,21.15,20.12,33.71,33.71,0,0,1,28,25.24,32.45,32.45,0,0,1,33.16,31.15Z"
            />
          </g>
        </g>
      </svg>
    ),
  },
  Entertainment: {
    iconWhite: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 300 300"
        style={{ ...navIconWhite }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <path d="M148.24,36.07a6.38,6.38,0,0,0-7.6-3.89l-34.82,8A330.69,330.69,0,0,0,40.57,62.69L8.18,77.8a6.39,6.39,0,0,0-3.6,7.75l29,84.19c7.68,22.27,27.48,38.5,52.1,42.69l34.09,5.8a69.52,69.52,0,0,1-2.6-43.77l2.46-9.09L78.16,180.14c-5.19-21.45,7-43,25.85-48.08a34.33,34.33,0,0,1,24,2.46l14.86-54.78a7,7,0,0,1,8.07-4.83l11.33,1.83ZM61.51,126.22A13.53,13.53,0,1,1,69.89,109,13.54,13.54,0,0,1,61.51,126.22Zm65-22.36a13.54,13.54,0,1,1,8.38-17.21A13.55,13.55,0,0,1,126.47,103.86Z" />
            <path d="M290.79,121.64l-33.32-12.91a329.4,329.4,0,0,0-66.61-18l-25.22-4.08-10-1.63a6.38,6.38,0,0,0-7.33,4.37l-13.41,49.46-6.32,23.39L125,175.32a63.44,63.44,0,0,0,3.66,42.83,70.33,70.33,0,0,0,15.45,21.73l25.8,24.77a19.45,19.45,0,0,0,17.84,4.83l34.76-8.35c24.29-5.81,43-23.33,49.12-46.06l23.31-85.94A6.35,6.35,0,0,0,290.79,121.64ZM165,138.93a13.53,13.53,0,0,1,14.53-9.9,13.35,13.35,0,0,1,2.06.39A13.53,13.53,0,1,1,165,138.93Zm28.44,93.75c-19.22-3.33-33.16-22.61-29.79-43.27l71,17.67C228.77,225,210.83,235.66,193.45,232.68Zm64-68.69a13.53,13.53,0,1,1-9.54-16.59A13.56,13.56,0,0,1,257.43,164Z" />
          </g>
        </g>
      </svg>
    ),
    iconPurple: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 300 300"
        style={{ ...navIconPurple }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <path d="M148.24,36.07a6.38,6.38,0,0,0-7.6-3.89l-34.82,8A330.69,330.69,0,0,0,40.57,62.69L8.18,77.8a6.39,6.39,0,0,0-3.6,7.75l29,84.19c7.68,22.27,27.48,38.5,52.1,42.69l34.09,5.8a69.52,69.52,0,0,1-2.6-43.77l2.46-9.09L78.16,180.14c-5.19-21.45,7-43,25.85-48.08a34.33,34.33,0,0,1,24,2.46l14.86-54.78a7,7,0,0,1,8.07-4.83l11.33,1.83ZM61.51,126.22A13.53,13.53,0,1,1,69.89,109,13.54,13.54,0,0,1,61.51,126.22Zm65-22.36a13.54,13.54,0,1,1,8.38-17.21A13.55,13.55,0,0,1,126.47,103.86Z" />
            <path d="M290.79,121.64l-33.32-12.91a329.4,329.4,0,0,0-66.61-18l-25.22-4.08-10-1.63a6.38,6.38,0,0,0-7.33,4.37l-13.41,49.46-6.32,23.39L125,175.32a63.44,63.44,0,0,0,3.66,42.83,70.33,70.33,0,0,0,15.45,21.73l25.8,24.77a19.45,19.45,0,0,0,17.84,4.83l34.76-8.35c24.29-5.81,43-23.33,49.12-46.06l23.31-85.94A6.35,6.35,0,0,0,290.79,121.64ZM165,138.93a13.53,13.53,0,0,1,14.53-9.9,13.35,13.35,0,0,1,2.06.39A13.53,13.53,0,1,1,165,138.93Zm28.44,93.75c-19.22-3.33-33.16-22.61-29.79-43.27l71,17.67C228.77,225,210.83,235.66,193.45,232.68Zm64-68.69a13.53,13.53,0,1,1-9.54-16.59A13.56,13.56,0,0,1,257.43,164Z" />
          </g>
        </g>
      </svg>
    ),
  },
  Golf: {
    iconWhite: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 93 98"
        style={{ ...navIconWhite }}
      >
        <g
          id="Artboard_1"
          data-name="Artboard – 1"
          clipPath="url(#clip-Artboard_1)"
        >
          <g
            id="Icon_material-golf-course"
            data-name="Icon material-golf-course"
            transform="translate(3.529 2.504)"
          >
            <path
              d="M53.479,40.239A13.239,13.239,0,1,1,40.239,27,13.239,13.239,0,0,1,53.479,40.239Z"
              transform="translate(26.463 27.686)"
            />
            <path
              d="M42.172,20.05,19.912,3V81.292H14.347V73.767C9.367,75.29,6,78.073,6,81.292c0,4.785,7.485,8.7,16.695,8.7s16.695-3.915,16.695-8.7c0-4.306-6.01-7.873-13.912-8.569V33.36Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
      </svg>
    ),
    iconPurple: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 93 98"
        style={{ ...navIconPurple }}
      >
        <g
          id="Artboard_1"
          data-name="Artboard – 1"
          clipPath="url(#clip-Artboard_1)"
        >
          <g
            id="Icon_material-golf-course"
            data-name="Icon material-golf-course"
            transform="translate(3.529 2.504)"
          >
            <path
              d="M53.479,40.239A13.239,13.239,0,1,1,40.239,27,13.239,13.239,0,0,1,53.479,40.239Z"
              transform="translate(26.463 27.686)"
            />
            <path
              d="M42.172,20.05,19.912,3V81.292H14.347V73.767C9.367,75.29,6,78.073,6,81.292c0,4.785,7.485,8.7,16.695,8.7s16.695-3.915,16.695-8.7c0-4.306-6.01-7.873-13.912-8.569V33.36Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
      </svg>
    ),
  },
  Treats: {
    iconWhite: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 59.04 58.42"
        style={{ ...navIconWhite }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_3" data-name="Layer 3">
            <path d="M58.68,7.06,56.75,9A1.24,1.24,0,0,1,55,9l-4.42,4.43c1.33,4.05-2.12,12.2-4.86,14.94L16.79,57.3a3.86,3.86,0,0,1-5.45,0L1.13,47.09a3.86,3.86,0,0,1,0-5.46L30.06,12.7c2.81-2.8,11.4-6,15.38-4.32l4.5-4.49a1.21,1.21,0,0,1,.12-1.6L52,.37a1.23,1.23,0,0,1,1.75,0l5,4.94A1.24,1.24,0,0,1,58.68,7.06Z" />
            <rect
              className="cls-1"
              x="20.62"
              y="24.79"
              width="17.18"
              height="8.84"
              rx="0.64"
              transform="translate(29.21 -12.1) rotate(45)"
            />
          </g>
        </g>
      </svg>
    ),
    iconPurple: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 59.04 58.42"
        style={{ ...navIconPurple }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_3" data-name="Layer 3">
            <path d="M58.68,7.06,56.75,9A1.24,1.24,0,0,1,55,9l-4.42,4.43c1.33,4.05-2.12,12.2-4.86,14.94L16.79,57.3a3.86,3.86,0,0,1-5.45,0L1.13,47.09a3.86,3.86,0,0,1,0-5.46L30.06,12.7c2.81-2.8,11.4-6,15.38-4.32l4.5-4.49a1.21,1.21,0,0,1,.12-1.6L52,.37a1.23,1.23,0,0,1,1.75,0l5,4.94A1.24,1.24,0,0,1,58.68,7.06Z" />
            <rect
              className="cls-1"
              x="20.62"
              y="24.79"
              width="17.18"
              height="8.84"
              rx="0.64"
              transform="translate(29.21 -12.1) rotate(45)"
            />
          </g>
        </g>
      </svg>
    ),
  },
  itinerary: {
    iconWhite: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 52.51 70.01"
        style={{ ...navIconWhite }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <path
              id="Icon_awesome-clipboard-list"
              data-name="Icon awesome-clipboard-list"
              d="M45.94,8.75H35a8.75,8.75,0,0,0-17.5,0H6.57A6.57,6.57,0,0,0,0,15.32H0V63.45A6.57,6.57,0,0,0,6.57,70H45.94a6.57,6.57,0,0,0,6.57-6.56V15.32A6.57,6.57,0,0,0,45.94,8.75ZM13.13,58A3.28,3.28,0,0,1,10,53.82a3.25,3.25,0,0,1,2.29-2.3,3.29,3.29,0,0,1,4.16,3.17h0A3.27,3.27,0,0,1,13.14,58Zm0-13.12A3.29,3.29,0,0,1,10,40.69a3.22,3.22,0,0,1,2.29-2.29,3.29,3.29,0,0,1,4.16,3.16h0a3.29,3.29,0,0,1-3.27,3.29Zm0-13.13A3.29,3.29,0,0,1,10,27.56a3.23,3.23,0,0,1,2.29-2.29,3.29,3.29,0,0,1,4.16,3.17h0a3.27,3.27,0,0,1-3.27,3.28ZM26.25,5.47a3.29,3.29,0,0,1,3.17,4.16,3.25,3.25,0,0,1-2.29,2.29A3.29,3.29,0,0,1,23,8.75h0a3.27,3.27,0,0,1,3.27-3.28Zm17.5,50.32a1.09,1.09,0,0,1-1.09,1.09H23a1.09,1.09,0,0,1-1.09-1.09V53.6A1.09,1.09,0,0,1,23,52.51H42.66a1.09,1.09,0,0,1,1.09,1.09Zm0-13.13a1.09,1.09,0,0,1-1.09,1.09H23a1.09,1.09,0,0,1-1.09-1.09V40.48A1.1,1.1,0,0,1,23,39.38H42.66a1.1,1.1,0,0,1,1.09,1.1Zm0-13.12a1.09,1.09,0,0,1-1.09,1.09H23a1.09,1.09,0,0,1-1.09-1.09V27.35A1.09,1.09,0,0,1,23,26.25H42.66a1.09,1.09,0,0,1,1.09,1.1Z"
            />
          </g>
        </g>
      </svg>
    ),
    iconPurple: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 52.51 70.01"
        style={{ ...navIconPurple }}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <path
              id="Icon_awesome-clipboard-list"
              data-name="Icon awesome-clipboard-list"
              d="M45.94,8.75H35a8.75,8.75,0,0,0-17.5,0H6.57A6.57,6.57,0,0,0,0,15.32H0V63.45A6.57,6.57,0,0,0,6.57,70H45.94a6.57,6.57,0,0,0,6.57-6.56V15.32A6.57,6.57,0,0,0,45.94,8.75ZM13.13,58A3.28,3.28,0,0,1,10,53.82a3.25,3.25,0,0,1,2.29-2.3,3.29,3.29,0,0,1,4.16,3.17h0A3.27,3.27,0,0,1,13.14,58Zm0-13.12A3.29,3.29,0,0,1,10,40.69a3.22,3.22,0,0,1,2.29-2.29,3.29,3.29,0,0,1,4.16,3.16h0a3.29,3.29,0,0,1-3.27,3.29Zm0-13.13A3.29,3.29,0,0,1,10,27.56a3.23,3.23,0,0,1,2.29-2.29,3.29,3.29,0,0,1,4.16,3.17h0a3.27,3.27,0,0,1-3.27,3.28ZM26.25,5.47a3.29,3.29,0,0,1,3.17,4.16,3.25,3.25,0,0,1-2.29,2.29A3.29,3.29,0,0,1,23,8.75h0a3.27,3.27,0,0,1,3.27-3.28Zm17.5,50.32a1.09,1.09,0,0,1-1.09,1.09H23a1.09,1.09,0,0,1-1.09-1.09V53.6A1.09,1.09,0,0,1,23,52.51H42.66a1.09,1.09,0,0,1,1.09,1.09Zm0-13.13a1.09,1.09,0,0,1-1.09,1.09H23a1.09,1.09,0,0,1-1.09-1.09V40.48A1.1,1.1,0,0,1,23,39.38H42.66a1.1,1.1,0,0,1,1.09,1.1Zm0-13.12a1.09,1.09,0,0,1-1.09,1.09H23a1.09,1.09,0,0,1-1.09-1.09V27.35A1.09,1.09,0,0,1,23,26.25H42.66a1.09,1.09,0,0,1,1.09,1.1Z"
            />
          </g>
        </g>
      </svg>
    ),
  },
  Folio: {
    iconWhite: (
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="532.195px"
        height="532.196px"
        viewBox="0 0 532.195 532.196"
        style={{ ...navIconWhite }}
      >
        <g>
          <g>
            <polygon
              points="386.605,508.282 66.022,508.282 66.022,56.797 131.992,56.797 131.992,103.132 336.09,103.132 336.09,56.797 
       386.605,56.797 386.605,248.536 410.521,225.076 410.521,32.883 336.09,32.883 336.09,0 274.038,0 274.038,23.915 195.329,23.915 
       195.329,0 131.992,0 131.992,32.883 42.107,32.883 42.107,532.196 410.521,532.196 410.521,373.667 386.605,403.141 		"
            />
            <rect x="111.125" y="165.908" width="245.82" height="17.936" />
            <rect x="111.125" y="209.254" width="245.82" height="17.936" />
            <rect x="111.125" y="254.322" width="245.82" height="17.936" />
            <path
              d="M490.088,255.051l-38.511-36.83l-17.516,18.298l-8.618-8.244l-155.13,162.184l-1.244,5.23l-17.136,71.523l70.693-20.295
       l5.173-1.483l155.13-162.172l-10.357-9.908L490.088,255.051z M450.946,270.284L310.19,417.421l-11.116-10.638L439.83,259.641
       L450.946,270.284z M425.841,246.276l9.388,8.98L294.473,402.393l-9.388-8.991L425.841,246.276z M281.301,445.54l-9.026-8.629
       l7.438-31.037l32.275,30.85L281.301,445.54z M324.18,430.792l-9.389-8.991l140.756-147.125l9.389,8.985L324.18,430.792z"
            />
          </g>
        </g>
      </svg>
    ),
    iconPurple: (
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="532.195px"
        height="532.196px"
        viewBox="0 0 532.195 532.196"
        style={{ ...navIconPurple }}
      >
        <g>
          <g>
            <polygon
              points="386.605,508.282 66.022,508.282 66.022,56.797 131.992,56.797 131.992,103.132 336.09,103.132 336.09,56.797 
       386.605,56.797 386.605,248.536 410.521,225.076 410.521,32.883 336.09,32.883 336.09,0 274.038,0 274.038,23.915 195.329,23.915 
       195.329,0 131.992,0 131.992,32.883 42.107,32.883 42.107,532.196 410.521,532.196 410.521,373.667 386.605,403.141 		"
            />
            <rect x="111.125" y="165.908" width="245.82" height="17.936" />
            <rect x="111.125" y="209.254" width="245.82" height="17.936" />
            <rect x="111.125" y="254.322" width="245.82" height="17.936" />
            <path
              d="M490.088,255.051l-38.511-36.83l-17.516,18.298l-8.618-8.244l-155.13,162.184l-1.244,5.23l-17.136,71.523l70.693-20.295
       l5.173-1.483l155.13-162.172l-10.357-9.908L490.088,255.051z M450.946,270.284L310.19,417.421l-11.116-10.638L439.83,259.641
       L450.946,270.284z M425.841,246.276l9.388,8.98L294.473,402.393l-9.388-8.991L425.841,246.276z M281.301,445.54l-9.026-8.629
       l7.438-31.037l32.275,30.85L281.301,445.54z M324.18,430.792l-9.389-8.991l140.756-147.125l9.389,8.985L324.18,430.792z"
            />
          </g>
        </g>
      </svg>
    ),
  },
  rightNavArrow: {
    iconWhite: (
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 31.143 31.143"
        style={{ ...navIconWhite }}
      >
        <g>
          <g id="c100_arrow">
            <path
              d="M0,15.571c0.001,1.702,1.383,3.081,3.085,3.083l17.528-0.002l-4.738,4.739c-1.283,1.284-1.349,3.301-0.145,4.507
       c1.205,1.201,3.222,1.138,4.507-0.146l9.896-9.898c1.287-1.283,1.352-3.301,0.146-4.506c-0.033-0.029-0.068-0.051-0.1-0.08
       c-0.041-0.043-0.07-0.094-0.113-0.139l-9.764-9.762c-1.268-1.266-3.27-1.316-4.474-0.111c-1.205,1.205-1.153,3.208,0.111,4.476
       l4.755,4.754H3.085C1.381,12.485,0,13.865,0,15.571z"
            />
          </g>
          <g id="Capa_1_46_"></g>
        </g>
      </svg>
    ),
    iconPurple: (
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 31.143 31.143"
        style={{ ...navIconPurple }}
      >
        <g>
          <g id="c100_arrow">
            <path
              d="M0,15.571c0.001,1.702,1.383,3.081,3.085,3.083l17.528-0.002l-4.738,4.739c-1.283,1.284-1.349,3.301-0.145,4.507
       c1.205,1.201,3.222,1.138,4.507-0.146l9.896-9.898c1.287-1.283,1.352-3.301,0.146-4.506c-0.033-0.029-0.068-0.051-0.1-0.08
       c-0.041-0.043-0.07-0.094-0.113-0.139l-9.764-9.762c-1.268-1.266-3.27-1.316-4.474-0.111c-1.205,1.205-1.153,3.208,0.111,4.476
       l4.755,4.754H3.085C1.381,12.485,0,13.865,0,15.571z"
            />
          </g>
          <g id="Capa_1_46_"></g>
        </g>
      </svg>
    ),
  },
};

export const dropDownArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Group_112"
    data-name="Group 112"
    width="24.927"
    height="18.695"
    viewBox="0 0 24.927 18.695"
    style={{ fill: "#525e8b" }}
  >
    <defs></defs>
    <path
      id="Caret"
      className="cls-1"
      d="M11.631,1.248a1,1,0,0,1,1.664,0l10.6,15.893a1,1,0,0,1-.832,1.555H1.869a1,1,0,0,1-.832-1.555Z"
      transform="translate(24.927 18.695) rotate(180)"
    />
  </svg>
);

export const exclamation = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="37.932"
    height="36.096"
    viewBox="0 0 37.932 36.096"
    style={{ fill: "#fff" }}
  >
    <path
      id="exclamation-diamond-fill"
      className="cls-1"
      d="M21.454.981a3.648,3.648,0,0,0-4.979,0L1.032,15.68a3.231,3.231,0,0,0,0,4.733l15.448,14.7a3.642,3.642,0,0,0,4.974,0L36.9,20.414a3.231,3.231,0,0,0,0-4.733ZM18.964,9.025A2.082,2.082,0,0,1,21.1,11.269l-.83,7.912a1.316,1.316,0,0,1-2.608,0l-.83-7.912A1.98,1.98,0,0,1,17.374,9.7a2.2,2.2,0,0,1,1.59-.672Zm0,13.537A2.259,2.259,0,1,1,16.6,24.818,2.316,2.316,0,0,1,18.969,22.561Z"
      transform="translate(-0.001)"
    />
  </svg>
);

export const check_circle = (
  width = "32.33",
  height = "31.537",
  new_styles
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{
        fill: "none",
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "4px",
        ...new_styles,
      }}
    >
      <g
        id="Icon_feather-check-circle"
        data-name="Icon feather-check-circle"
        transform="translate(2.003 2.017)"
      >
        <path
          id="Path_45"
          data-name="Path 45"
          className="cls-1"
          d="M30.5,15.483v1.265A13.749,13.749,0,1,1,22.345,4.182"
          transform="translate(-3 -2.991)"
        />
        <path
          id="Path_46"
          data-name="Path 46"
          className="cls-1"
          d="M31.374,6,17.625,19.763,13.5,15.638"
          transform="translate(-3.876 -3.242)"
        />
      </g>
    </svg>
  );
};
export const rightArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{ fill: "#fff" }}
  >
    <path
      id="arrow-right-circle-fill"
      className="cls-1"
      d="M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0ZM4.5,7.5a.5.5,0,0,0,0,1h5.793L8.146,10.646a.5.5,0,1,0,.708.708l3-3a.5.5,0,0,0,0-.708l-3-3a.5.5,0,1,0-.708.708L10.293,7.5Z"
    />
  </svg>
);

export const leftArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{ fill: "#fff" }}
  >
    <path
      id="arrow-left-circle-fill"
      className="cls-1"
      d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm3.5,7.5a.5.5,0,0,1,0,1H5.707l2.147,2.146a.5.5,0,1,1-.708.708l-3-3a.5.5,0,0,1,0-.708l3-3a.5.5,0,0,1,.708.708L5.707,7.5Z"
    />
  </svg>
);

export const editPencil = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 212.05 212.34">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_2-2" data-name="Layer 2">
        <path d="M173.33,83.35,58.28,198.4l-.19-.19a3.11,3.11,0,0,1-.46.16L3.5,212.25a2.8,2.8,0,0,1-3.41-3.41L14,154.71a2.09,2.09,0,0,1,.16-.44l-.49-.49L128.71,38.72Z" />
        <path
          d="M169.89,6.84h22.47a20.32,20.32,0,0,1,20.32,20.32V55a0,0,0,0,1,0,0H149.57a0,0,0,0,1,0,0V27.16A20.32,20.32,0,0,1,169.89,6.84Z"
          transform="translate(74.92 -119.01) rotate(45)"
        />
      </g>
    </g>
  </svg>
);

export const undoSign = (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 216.318 216.318"
    style={{ enableBackground: "new 0 0 216.318 216.318;" }}
  >
    <path
      d="M118.913,22.172V0L45.295,43.154l73.617,43.155V62.604c27,5.108,46.549,28.418,46.549,56.331
	c0,31.641-25.659,57.383-57.3,57.383s-57.341-25.742-57.341-57.383c0-8.319,1.756-16.334,5.179-23.821L19.632,78.483
	c-5.825,12.743-8.774,26.354-8.774,40.452c0,53.697,43.688,97.383,97.385,97.383s97.218-43.686,97.218-97.383
	C205.461,68.939,167.913,27.629,118.913,22.172z"
    />
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
);

export const xSign = (
  size = "24px",
  backgroundFill = "#ac1b1b",
  symbolFill = "#fff"
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${size.substring(0, 2)} ${size.substring(0, 2)}`}
  >
    <g id="Group_647" data-name="Group 647" transform="translate(-386 -241)">
      <circle
        id="Icon"
        className="cls-1"
        style={{ fill: backgroundFill }}
        cx="12"
        cy="12"
        r="12"
        transform="translate(386 241)"
      />
      <path
        id="Line"
        className="cls-2"
        style={{ fill: symbolFill }}
        d="M.293,1.707A1,1,0,0,1,1.707.293l8,8A1,1,0,0,1,8.293,9.707Z"
        transform="translate(393 248)"
      />
      <path
        id="Line-2"
        data-name="Line"
        className="cls-2"
        style={{ fill: symbolFill }}
        d="M-.293,1.707a1,1,0,0,0,0-1.414,1,1,0,0,0-1.414,0l-8,8a1,1,0,0,0,0,1.414,1,1,0,0,0,1.414,0Z"
        transform="translate(403 248)"
      />
    </g>
  </svg>
);

export const done_sign = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66.3 66.3">
    <defs></defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_2-2" data-name="Layer 2">
        <circle cx="33.15" cy="33.15" r="33.15" />
        <polyline
          className="cls-1"
          points="14.61 35.16 29.06 46.49 51.3 19.81"
        />
      </g>
    </g>
  </svg>
);

export const search_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33.434"
    height="33.439"
    viewBox="0 0 33.434 33.439"
  >
    <path
      id="Icon_awesome-search"
      data-name="Icon awesome-search"
      d="M32.979,28.91,26.468,22.4a1.566,1.566,0,0,0-1.11-.457H24.293a13.577,13.577,0,1,0-2.351,2.351v1.064a1.566,1.566,0,0,0,.457,1.11l6.511,6.511a1.561,1.561,0,0,0,2.214,0l1.848-1.848A1.575,1.575,0,0,0,32.979,28.91Zm-19.4-6.968a8.359,8.359,0,1,1,8.359-8.359A8.354,8.354,0,0,1,13.583,21.942Z"
      fill="#fff"
    />
  </svg>
);

export const home_icon = (fill) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    dataname="Layer 1"
    viewBox="0 0 300 300"
    style={{ fill, width: "35px" }}
  >
    <path d="M286.66,159h-34a5.7,5.7,0,0,0-5.7,5.7V290.3a5.7,5.7,0,0,1-5.7,5.7H177V214.09A11.1,11.1,0,0,0,165.91,203H132.09A11.1,11.1,0,0,0,121,214.09V296H56.7a5.7,5.7,0,0,1-5.7-5.7V164.7a5.7,5.7,0,0,0-5.7-5.7h-32a5.7,5.7,0,0,1-4.13-9.64l136.67-143a5.7,5.7,0,0,1,8.24,0l136.67,143A5.7,5.7,0,0,1,286.66,159Z" />
  </svg>
);

export const left_arrow = (fill) => (
  <svg
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    width="33.434"
    height="20"
    viewBox="0 0 451.847 451.847"
    style={{ fill: fill, enableBackground: "new 0 0 451.847 451.847" }}
  >
    <g>
      <path
        d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
      c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
      c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"
      />
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
);

export const leftArrowAddOns = (
  <svg
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    width="33.434"
    height="20"
    viewBox="0 0 451.847 451.847"
    style={{ fill: "#4d5b89", enableBackground: "new 0 0 451.847 451.847" }}
  >
    <g>
      <path
        d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
		c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
		c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"
      />
    </g>
  </svg>
);

export const DayUseServiceIcons = {
  Home: (size, fill) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="ionicon"
      viewBox="0 0 512 512"
      width={size}
      height={size}
      style={{ fill: fill }}
    >
      <title>Home</title>
      <path d="M261.56 101.28a8 8 0 00-11.06 0L66.4 277.15a8 8 0 00-2.47 5.79L63.9 448a32 32 0 0032 32H192a16 16 0 0016-16V328a8 8 0 018-8h80a8 8 0 018 8v136a16 16 0 0016 16h96.06a32 32 0 0032-32V282.94a8 8 0 00-2.47-5.79z" />
      <path d="M490.91 244.15l-74.8-71.56V64a16 16 0 00-16-16h-48a16 16 0 00-16 16v32l-57.92-55.38C272.77 35.14 264.71 32 256 32c-8.68 0-16.72 3.14-22.14 8.63l-212.7 203.5c-6.22 6-7 15.87-1.34 22.37A16 16 0 0043 267.56L250.5 69.28a8 8 0 0111.06 0l207.52 198.28a16 16 0 0022.59-.44c6.14-6.36 5.63-16.86-.76-22.97z" />
    </svg>
  ),
  HomeMobile: (size, fill) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 200"
      style={{ fill: fill }}
    >
      <g id="Home">
        <g>
          <path d="m93.7,180.42h-8.26v-22.69h-23.2v22.69h-8.23v-50.33h8.23v20.59h23.2v-20.59h8.26v50.33Z" />
          <path d="m139.86,161.31c0,6.22-1.6,11.08-4.79,14.56s-7.63,5.23-13.32,5.23c-3.56,0-6.7-.8-9.43-2.41s-4.83-3.91-6.3-6.92c-1.47-3.01-2.2-6.5-2.2-10.47,0-6.17,1.58-10.99,4.75-14.46,3.17-3.47,7.63-5.2,13.39-5.2s9.87,1.77,13.08,5.32c3.21,3.54,4.82,8.32,4.82,14.34Zm-27.71,0c0,8.79,3.25,13.19,9.74,13.19s9.64-4.4,9.64-13.19-3.24-13.05-9.71-13.05c-3.4,0-5.86,1.13-7.38,3.37-1.53,2.25-2.29,5.47-2.29,9.67Z" />
          <path d="m181.24,180.42h-8.12v-23.48c0-2.92-.55-5.09-1.65-6.52-1.1-1.44-2.82-2.15-5.16-2.15-3.12,0-5.41,1.01-6.87,3.05-1.46,2.03-2.19,5.41-2.19,10.14v18.97h-8.09v-38.08h6.33l1.14,4.99h.41c1.05-1.81,2.59-3.21,4.6-4.2s4.22-1.48,6.63-1.48c5.85,0,9.73,2,11.64,5.99h.55c1.12-1.88,2.71-3.35,4.75-4.41s4.38-1.58,7.02-1.58c4.54,0,7.85,1.15,9.93,3.44,2.08,2.3,3.12,5.79,3.12,10.5v24.82h-8.09v-23.48c0-2.92-.56-5.09-1.67-6.52-1.11-1.44-2.84-2.15-5.18-2.15-3.15,0-5.44.98-6.9,2.94-1.46,1.97-2.19,4.98-2.19,9.04v20.17Z" />
          <path d="m233.2,181.11c-5.92,0-10.55-1.73-13.89-5.18-3.34-3.45-5.01-8.21-5.01-14.27s1.55-11.11,4.65-14.67c3.1-3.56,7.36-5.34,12.77-5.34,5.03,0,9,1.52,11.91,4.58,2.91,3.05,4.37,7.25,4.37,12.6v4.37h-25.37c.12,3.69,1.11,6.54,3,8.52,1.88,1.99,4.53,2.98,7.95,2.98,2.25,0,4.34-.21,6.28-.64,1.94-.42,4.02-1.13,6.25-2.11v6.58c-1.97.94-3.97,1.61-5.99,2s-4.33.59-6.92.59Zm-1.48-33.33c-2.57,0-4.63.82-6.18,2.44-1.55,1.63-2.47,4-2.77,7.13h17.28c-.05-3.14-.8-5.53-2.27-7.14-1.47-1.62-3.49-2.43-6.06-2.43Z" />
        </g>
      </g>
      <g id="home">
        <path
          id="Path_581"
          data-name="Path 581"
          d="m151.01,32.16c-.59-.57-1.53-.57-2.13,0l-35.4,33.82c-.3.29-.48.69-.48,1.11v31.74c0,3.4,2.76,6.15,6.15,6.15h18.47c1.7,0,3.08-1.38,3.08-3.08v-26.15c0-.85.69-1.54,1.54-1.54h15.38c.85,0,1.54.69,1.54,1.54h0v26.15c0,1.7,1.38,3.08,3.08,3.08h18.47c3.4,0,6.16-2.75,6.16-6.15h0v-31.75c0-.42-.17-.82-.48-1.11l-35.39-33.82Z"
        />
        <path
          id="Path_582"
          data-name="Path 582"
          d="m195.11,59.63l-14.39-13.76v-20.88c0-1.7-1.38-3.08-3.08-3.08h-9.23c-1.7,0-3.08,1.38-3.08,3.08v6.15l-11.14-10.65c-2.41-2.21-6.11-2.21-8.52,0l-40.91,39.14c-1.21,1.14-1.33,3.03-.26,4.3,1.11,1.28,3.06,1.42,4.34.31.04-.03.08-.07.12-.11l39.9-38.13c.59-.57,1.53-.57,2.13,0l39.9,38.13c1.22,1.17,3.17,1.14,4.34-.08,1.17-1.26,1.1-3.23-.14-4.42Z"
        />
      </g>
    </svg>
  ),
  DiscoverMobile: (size, fill) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 200"
      width={size}
      height={size}
      style={{ fill: fill }}
    >
      <path
        id="trail-sign"
        d="m194.46,75.31l-11.41-11.41c-1.15-1.16-2.72-1.81-4.35-1.8h-26.43v-6.16h27.71c3.4,0,6.16-2.76,6.16-6.16v-18.47c0-3.4-2.76-6.16-6.16-6.16h-27.71v-3.08c0-1.7-1.38-3.08-3.08-3.08s-3.08,1.38-3.08,3.08v3.08h-26.43c-1.63,0-3.2.64-4.35,1.8l-11.41,11.41c-1.2,1.2-1.2,3.15,0,4.35l11.41,11.41c1.15,1.16,2.72,1.81,4.35,1.8h26.43v6.16h-27.71c-3.4,0-6.16,2.76-6.16,6.16v18.47c0,3.4,2.76,6.16,6.16,6.16h27.71v9.24c0,1.7,1.38,3.08,3.08,3.08s3.08-1.38,3.08-3.08v-9.24h26.43c1.63,0,3.2-.64,4.35-1.8l11.41-11.41c1.2-1.2,1.2-3.15,0-4.35Z"
      />
      <g id="Discover">
        <g>
          <path d="m60.66,155.84c0,7.82-2.17,13.8-6.51,17.94-4.34,4.13-10.6,6.21-18.77,6.21h-13.26v-47.38h14.65c7.54,0,13.41,2.03,17.6,6.09,4.19,4.06,6.29,9.77,6.29,17.15Zm-8.17.26c0-11.34-5.3-17.02-15.91-17.02h-6.71v34.39h5.51c11.41,0,17.11-5.79,17.11-17.37Z" />
          <path d="m69.57,134.64c0-1.36.37-2.41,1.12-3.14.75-.74,1.81-1.1,3.19-1.1s2.38.36,3.13,1.1c.75.73,1.12,1.78,1.12,3.14s-.37,2.32-1.12,3.06-1.79,1.12-3.13,1.12-2.45-.37-3.19-1.12-1.12-1.77-1.12-3.06Zm8.07,45.34h-7.62v-35.85h7.62v35.85Z" />
          <path d="m112.61,169.77c0,3.5-1.27,6.18-3.82,8.05-2.55,1.86-6.2,2.8-10.95,2.8s-8.61-.73-11.51-2.17v-6.58c4.21,1.94,8.14,2.92,11.77,2.92,4.69,0,7.03-1.42,7.03-4.25,0-.91-.26-1.67-.78-2.27-.52-.61-1.37-1.23-2.56-1.88-1.19-.65-2.84-1.39-4.96-2.2-4.12-1.6-6.92-3.2-8.38-4.8-1.46-1.6-2.19-3.68-2.19-6.22,0-3.07,1.24-5.45,3.71-7.15,2.48-1.7,5.84-2.54,10.1-2.54s8.2.85,11.96,2.56l-2.46,5.74c-3.87-1.6-7.12-2.4-9.76-2.4-4.02,0-6.03,1.14-6.03,3.44,0,1.12.53,2.07,1.57,2.85,1.05.78,3.33,1.85,6.85,3.21,2.96,1.14,5.11,2.19,6.45,3.14,1.34.95,2.33,2.04,2.98,3.29.65,1.24.97,2.72.97,4.46Z" />
          <path d="m135.3,180.63c-5.42,0-9.55-1.59-12.36-4.75-2.82-3.17-4.23-7.71-4.23-13.63s1.47-10.66,4.42-13.9,7.21-4.86,12.79-4.86c3.78,0,7.19.7,10.21,2.11l-2.3,6.13c-3.22-1.26-5.87-1.88-7.97-1.88-6.2,0-9.3,4.12-9.3,12.35,0,4.02.77,7.03,2.32,9.06,1.55,2.02,3.81,3.03,6.79,3.03,3.4,0,6.6-.84,9.63-2.53v6.64c-1.36.79-2.81,1.37-4.36,1.72-1.54.34-3.42.52-5.62.52Z" />
          <path d="m185.51,161.99c0,5.85-1.5,10.42-4.51,13.71-3,3.28-7.18,4.93-12.54,4.93-3.35,0-6.31-.76-8.88-2.27-2.57-1.52-4.55-3.69-5.93-6.51-1.38-2.84-2.07-6.12-2.07-9.85,0-5.82,1.49-10.36,4.47-13.61,2.98-3.27,7.19-4.89,12.61-4.89s9.29,1.67,12.32,5.01c3.03,3.34,4.54,7.84,4.54,13.5Zm-26.09,0c0,8.27,3.06,12.41,9.17,12.41s9.08-4.14,9.08-12.41-3.05-12.28-9.14-12.28c-3.2,0-5.51,1.05-6.95,3.18-1.43,2.11-2.16,5.15-2.16,9.11Z" />
          <path d="m202.43,179.98l-13.61-35.85h8.04l7.29,20.84c1.26,3.5,2.01,6.33,2.27,8.49h.26c.19-1.56.95-4.39,2.27-8.49l7.29-20.84h8.1l-13.68,35.85h-8.23Z" />
          <path d="m245.43,180.63c-5.57,0-9.93-1.63-13.08-4.88-3.14-3.26-4.72-7.73-4.72-13.43s1.46-10.46,4.38-13.81c2.92-3.35,6.93-5.02,12.02-5.02,4.73,0,8.47,1.43,11.21,4.31,2.75,2.87,4.12,6.82,4.12,11.86v4.12h-23.89c.11,3.48,1.05,6.15,2.82,8.02,1.77,1.86,4.27,2.8,7.49,2.8,2.12,0,4.09-.2,5.92-.6,1.83-.41,3.79-1.07,5.88-1.99v6.19c-1.86.88-3.74,1.51-5.64,1.88-1.9.36-4.07.55-6.51.55Zm-1.39-31.37c-2.42,0-4.36.76-5.82,2.3-1.46,1.53-2.33,3.77-2.61,6.71h16.27c-.04-2.97-.75-5.2-2.14-6.73-1.38-1.52-3.28-2.28-5.7-2.28Z" />
          <path d="m286.21,143.49c1.54,0,2.8.11,3.79.32l-.75,7.1c-1.08-.26-2.2-.39-3.37-.39-3.05,0-5.51.99-7.41,2.98-1.89,1.99-2.84,4.57-2.84,7.75v18.73h-7.62v-35.85h5.96l1,6.32h.39c1.19-2.14,2.74-3.84,4.65-5.09,1.91-1.26,3.97-1.88,6.17-1.88Z" />
        </g>
      </g>
    </svg>
  ),
  BookMobile: (size, fill) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 200"
      width={size}
      height={size}
      style={{ fill: fill }}
    >
      <g id="Book">
        <g>
          <path d="m73.12,133.92h13.49c6.26,0,10.78.91,13.57,2.74,2.79,1.82,4.18,4.7,4.18,8.64,0,2.65-.68,4.86-2.05,6.62-1.37,1.76-3.34,2.87-5.91,3.33v.31c3.19.6,5.54,1.79,7.04,3.56,1.5,1.77,2.25,4.17,2.25,7.2,0,4.08-1.43,7.28-4.28,9.59-2.85,2.31-6.81,3.47-11.89,3.47h-16.42v-45.46Zm7.43,18.78h7.15c3.11,0,5.38-.5,6.81-1.48,1.43-.99,2.15-2.66,2.15-5.02,0-2.14-.77-3.68-2.32-4.63-1.54-.96-4-1.43-7.35-1.43h-6.44v12.56Zm0,6.03v14.4h7.9c3.11,0,5.46-.6,7.04-1.79,1.59-1.2,2.38-3.08,2.38-5.64,0-2.36-.81-4.12-2.43-5.25-1.62-1.14-4.07-1.71-7.37-1.71h-7.52Z" />
          <path d="m144.88,162.12c0,5.61-1.44,10-4.32,13.15-2.88,3.15-6.89,4.73-12.03,4.73-3.21,0-6.05-.73-8.52-2.18-2.47-1.45-4.36-3.54-5.69-6.25-1.33-2.72-1.99-5.87-1.99-9.45,0-5.58,1.43-9.93,4.29-13.06,2.86-3.13,6.89-4.69,12.09-4.69s8.91,1.6,11.81,4.8c2.9,3.2,4.35,7.52,4.35,12.95Zm-25.03,0c0,7.94,2.93,11.91,8.8,11.91s8.71-3.97,8.71-11.91-2.92-11.78-8.77-11.78c-3.07,0-5.29,1.01-6.67,3.05-1.38,2.03-2.07,4.94-2.07,8.74Z" />
          <path d="m183.78,162.12c0,5.61-1.44,10-4.32,13.15-2.88,3.15-6.89,4.73-12.03,4.73-3.21,0-6.05-.73-8.52-2.18-2.47-1.45-4.36-3.54-5.69-6.25-1.33-2.72-1.99-5.87-1.99-9.45,0-5.58,1.43-9.93,4.29-13.06,2.86-3.13,6.89-4.69,12.09-4.69s8.91,1.6,11.81,4.8c2.9,3.2,4.35,7.52,4.35,12.95Zm-25.03,0c0,7.94,2.93,11.91,8.8,11.91s8.71-3.97,8.71-11.91-2.92-11.78-8.77-11.78c-3.07,0-5.29,1.01-6.67,3.05-1.38,2.03-2.07,4.94-2.07,8.74Z" />
          <path d="m199.23,161.22l4.14-5.16,10.38-11.07h8.43l-13.84,14.77,14.71,19.62h-8.58l-11.04-15.08-4.01,3.3v11.78h-7.24v-48.38h7.24v23.6l-.37,6.62h.19Z" />
        </g>
      </g>
      <path
        id="bookmark"
        d="m173.72,110.2c-.75,0-1.48-.27-2.05-.77l-25.66-22.82-25.66,22.82c-1.27,1.13-3.22,1.01-4.35-.26-.5-.56-.78-1.29-.78-2.05V36.31c0-6.8,5.52-12.31,12.31-12.31h36.95c6.8,0,12.31,5.52,12.31,12.31v70.81c0,1.7-1.38,3.08-3.08,3.08Z"
      />
    </svg>
  ),
  BasketMobile: (size, fill) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 200"
      width={size}
      height={size}
      style={{ fill: fill }}
    >
      <g id="Basket">
        <g>
          <path d="m55.17,133.01h13.79c6.4,0,11.02.93,13.87,2.8,2.85,1.86,4.27,4.81,4.27,8.83,0,2.71-.7,4.96-2.1,6.77-1.4,1.8-3.41,2.93-6.04,3.4v.32c3.26.61,5.66,1.83,7.2,3.64,1.53,1.81,2.3,4.26,2.3,7.36,0,4.17-1.46,7.43-4.37,9.8-2.91,2.36-6.96,3.54-12.15,3.54h-16.78v-46.45Zm7.59,19.19h7.31c3.18,0,5.5-.51,6.96-1.51,1.46-1.01,2.19-2.72,2.19-5.13,0-2.18-.79-3.76-2.37-4.73-1.58-.98-4.08-1.46-7.51-1.46h-6.58v12.84Zm0,6.16v14.71h8.07c3.18,0,5.58-.61,7.2-1.83,1.62-1.22,2.43-3.15,2.43-5.77,0-2.41-.83-4.21-2.48-5.37-1.65-1.17-4.16-1.75-7.53-1.75h-7.69Z" />
          <path d="m119.31,179.46l-1.49-4.89h-.25c-1.7,2.14-3.4,3.59-5.12,4.37-1.72.77-3.92,1.16-6.61,1.16-3.45,0-6.15-.94-8.09-2.8-1.94-1.87-2.91-4.5-2.91-7.91,0-3.62,1.34-6.35,4.04-8.2,2.69-1.84,6.79-2.85,12.3-3.02l6.07-.19v-1.87c0-2.25-.52-3.92-1.57-5.04s-2.67-1.67-4.88-1.67c-1.8,0-3.53.26-5.18.79-1.65.52-3.24,1.15-4.77,1.87l-2.41-5.34c1.91-1,3.99-1.76,6.26-2.27,2.27-.52,4.4-.78,6.42-.78,4.47,0,7.84.97,10.12,2.92,2.28,1.95,3.42,5,3.42,9.18v23.67h-5.34Zm-11.12-5.08c2.71,0,4.89-.76,6.53-2.27,1.64-1.52,2.46-3.64,2.46-6.37v-3.05l-4.51.19c-3.52.13-6.07.71-7.67,1.76-1.6,1.05-2.4,2.65-2.4,4.81,0,1.56.46,2.78,1.4,3.64.93.86,2.33,1.29,4.19,1.29Z" />
          <path d="m158.68,169.45c0,3.43-1.25,6.06-3.75,7.9-2.5,1.83-6.08,2.75-10.74,2.75s-8.44-.71-11.28-2.13v-6.45c4.13,1.91,7.97,2.86,11.53,2.86,4.59,0,6.89-1.39,6.89-4.16,0-.89-.25-1.64-.76-2.22-.51-.6-1.35-1.21-2.51-1.84-1.17-.64-2.79-1.36-4.86-2.16-4.05-1.57-6.78-3.14-8.21-4.7-1.43-1.57-2.14-3.61-2.14-6.1,0-3.01,1.21-5.35,3.64-7.01,2.42-1.67,5.72-2.49,9.9-2.49s8.04.83,11.72,2.51l-2.41,5.62c-3.79-1.57-6.98-2.35-9.56-2.35-3.94,0-5.91,1.12-5.91,3.37,0,1.1.51,2.03,1.54,2.8,1.03.76,3.27,1.81,6.72,3.15,2.9,1.12,5.01,2.14,6.32,3.08,1.31.93,2.29,2,2.92,3.22.64,1.22.95,2.67.95,4.37Z" />
          <path d="m173.96,160.9l4.23-5.27,10.61-11.31h8.61l-14.14,15.09,15.03,20.05h-8.77l-11.28-15.41-4.1,3.37v12.04h-7.4v-49.44h7.4v24.11l-.38,6.77h.19Z" />
          <path d="m219.3,180.09c-5.46,0-9.74-1.6-12.82-4.78-3.08-3.19-4.62-7.58-4.62-13.17s1.43-10.25,4.29-13.53c2.86-3.29,6.79-4.92,11.79-4.92,4.64,0,8.3,1.41,10.99,4.23,2.69,2.81,4.04,6.69,4.04,11.63v4.04h-23.42c.11,3.41,1.03,6.03,2.76,7.86,1.74,1.83,4.18,2.75,7.34,2.75,2.08,0,4.01-.2,5.8-.59,1.79-.4,3.71-1.05,5.77-1.95v6.07c-1.82.87-3.67,1.48-5.53,1.84-1.86.36-3.99.54-6.39.54Zm-1.37-30.76c-2.37,0-4.27.75-5.7,2.26-1.43,1.5-2.28,3.69-2.56,6.58h15.95c-.04-2.91-.74-5.1-2.1-6.59-1.36-1.49-3.22-2.24-5.59-2.24Z" />
          <path d="m254.54,174.06c1.82,0,3.64-.29,5.46-.86v5.62c-.83.36-1.89.66-3.19.91-1.3.24-2.65.37-4.05.37-7.08,0-10.61-3.73-10.61-11.18v-18.94h-4.8v-3.3l5.15-2.73,2.54-7.43h4.61v7.82h10.01v5.66h-10.01v18.81c0,1.8.45,3.13,1.35,3.99.9.86,2.08,1.29,3.54,1.29Z" />
        </g>
      </g>
      <path
        id="basket"
        d="m187.96,48.62h-14.85l-21.1-28.15c-1.24-1.63-3.56-1.96-5.2-.73-.27.21-.52.45-.73.73l-21.1,28.15h-14.85c-4.16-.01-7.53,3.35-7.54,7.51-.01.71.09,1.41.3,2.09l10.71,37.76c1.44,5.06,6.05,8.55,11.31,8.55h48.29c5.25-.02,9.86-3.49,11.33-8.54l10.73-37.8c.05-.19.08-.37.1-.56l.13-1.14c.01-.12.01-.24.01-.36-.01-4.16-3.4-7.52-7.54-7.51Zm-39.08,36.4c-4.82.01-8.73-3.89-8.73-8.71h0c0-4.82,3.91-8.73,8.71-8.73s8.73,3.91,8.73,8.71-3.89,8.73-8.71,8.73Zm-14.65-36.4l14.81-19.75,14.81,19.75h-29.62Z"
      />
    </svg>
  ),
  TrailSign: (size, fill) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      class="ionicon"
      viewBox="0 0 512 512"
      style={{ fill: fill }}
    >
      <title>Trail Sign</title>
      <path
        stroke={fill}
        d="M491.31 324.69L432 265.37a31.8 31.8 0 00-22.63-9.37H272v-32h144a32 32 0 0032-32V96a32 32 0 00-32-32H272V48a16 16 0 00-32 0v16H102.63A31.8 31.8 0 0080 73.37l-59.31 59.32a16 16 0 000 22.62L80 214.63a31.8 31.8 0 0022.63 9.37H240v32H96a32 32 0 00-32 32v96a32 32 0 0032 32h144v48a16 16 0 0032 0v-48h137.37a31.8 31.8 0 0022.63-9.37l59.31-59.32a16 16 0 000-22.62z"
      />
    </svg>
  ),
  Location: (fill) => (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="413.099px"
      height="413.099px"
      viewBox="0 0 413.099 413.099"
      style={{ fill: fill }}
    >
      <g>
        <g>
          <path
            d="M206.549,0L206.549,0c-82.6,0-149.3,66.7-149.3,149.3c0,28.8,9.2,56.3,22,78.899l97.3,168.399c6.1,11,18.4,16.5,30,16.5
     c11.601,0,23.3-5.5,30-16.5l97.3-168.299c12.9-22.601,22-49.601,22-78.901C355.849,66.8,289.149,0,206.549,0z M206.549,193.4
     c-30,0-54.5-24.5-54.5-54.5s24.5-54.5,54.5-54.5s54.5,24.5,54.5,54.5C261.049,169,236.549,193.4,206.549,193.4z"
          />
        </g>
      </g>
    </svg>
  ),
  Basket: (size, fill) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="ionicon"
      viewBox="0 0 512 512"
      width={size}
      height={size}
      style={{ fill: fill }}
    >
      <title>Basket</title>
      <path d="M424.11 192H360L268.8 70.4a16 16 0 00-25.6 0L152 192H87.89a32.57 32.57 0 00-32.62 32.44 30.3 30.3 0 001.31 9l46.27 163.14a50.72 50.72 0 0048.84 36.91h208.62a51.21 51.21 0 0049-36.86l46.33-163.36a15.62 15.62 0 00.46-2.36l.53-4.93a13.3 13.3 0 00.09-1.55A32.57 32.57 0 00424.11 192zM256 106.67L320 192H192zm0 245a37.7 37.7 0 1137.88-37.7A37.87 37.87 0 01256 351.63z" />
    </svg>
  ),
  CreditCard: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30.745"
      height="23.912"
      viewBox="0 0 30.745 23.912"
      style={{ fill: "#fff" }}
    >
      <path
        id="Icon_awesome-credit-card"
        data-name="Icon awesome-credit-card"
        class="cls-1"
        d="M0,23.6a2.563,2.563,0,0,0,2.562,2.562h25.62A2.563,2.563,0,0,0,30.745,23.6V14.206H0Zm10.248-3.63a.642.642,0,0,1,.641-.641h7.259a.642.642,0,0,1,.641.641v2.135a.642.642,0,0,1-.641.641H10.889a.642.642,0,0,1-.641-.641Zm-6.832,0a.642.642,0,0,1,.641-.641H7.9a.642.642,0,0,1,.641.641v2.135a.642.642,0,0,1-.641.641H4.057a.642.642,0,0,1-.641-.641ZM30.745,4.812V7.374H0V4.812A2.563,2.563,0,0,1,2.562,2.25h25.62A2.563,2.563,0,0,1,30.745,4.812Z"
        transform="translate(0 -2.25)"
      />
    </svg>
  ),
  List: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.912"
      height="23.912"
      viewBox="0 0 23.912 23.912"
      style={{ fill: "#fff" }}
    >
      <path
        id="Icon_material-format-align-justify"
        data-name="Icon material-format-align-justify"
        class="cls-1"
        d="M4.5,28.412H28.412V25.755H4.5Zm0-5.314H28.412V20.442H4.5Zm0-5.314H28.412V15.128H4.5Zm0-5.314H28.412V9.814H4.5ZM4.5,4.5V7.157H28.412V4.5Z"
        transform="translate(-4.5 -4.5)"
      />
    </svg>
  ),
  Recipe: (size, fill) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="ionicon"
      width={size}
      height={size}
      viewBox="0 0 512 512"
      style={{ fill: fill }}
    >
      <path d="M400 480a16 16 0 01-10.63-4L256 357.41 122.63 476A16 16 0 0196 464V96a64.07 64.07 0 0164-64h192a64.07 64.07 0 0164 64v368a16 16 0 01-16 16z" />
    </svg>
  ),
};

export const Logos = {
  DayUseLoginPageLogoShort: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="200"
      viewBox="0 0 1613.78 626.585"
    >
      <g id="Group_1626" data-name="Group 1626" transform="translate(0 0)">
        <g
          id="Group_1621"
          data-name="Group 1621"
          class="cls-2"
          style={{ fill: "clip-path: url(#clip-path)" }}
          transform="translate(0 0)"
        >
          <path
            id="Path_376"
            data-name="Path 376"
            class="cls-3"
            style={{ fill: "#161615" }}
            d="M76.628,0h82.146q53.633,0,83.677,25.628T272.49,97.42q0,29.88-13.917,52.788a97.427,97.427,0,0,1-38.7,35.976q-24.786,13.075-57.032,13.068H76.628l-.682-12.894L96.655,181.6q.682-3.058,1.19-17.313t.508-32.587V67.888q0-20.023-.508-33.944t-1.19-16.3L75.946,12.9Zm51.257,18.329q0,3.058-.167,8.316-.18,5.274-.341,14.94-.18,9.666-.174,26.3V131.7q0,10.187.174,19.178t.675,16.123q.511,7.129.849,11.885,10.859,1.354,19.519,2.206t16.8.849q35.976,0,54.652-19.185,18.66-19.171,18.67-55.495,0-22.069-5.435-39.211T216.989,39.372a68.758,68.758,0,0,0-26.136-17.48q-15.451-5.936-35.816-5.936-6.106,0-12.894.508a136.165,136.165,0,0,0-14.258,1.865"
            transform="translate(431.715 0.001)"
          />
          <path
            id="Path_377"
            data-name="Path 377"
            class="cls-3"
            style={{ fill: "#161615" }}
            d="M160.241,158.958a51.843,51.843,0,0,1-24.1-5.428,44.429,44.429,0,0,1-16.457-13.917,30.341,30.341,0,0,1-5.943-17.654q0-11.531,7.466-19.011,7.46-7.46,24.439-12.894l51.6-17.313V55.428a25.57,25.57,0,0,0-5.094-15.448A35.483,35.483,0,0,0,178.57,28.951a43.422,43.422,0,0,0-19.011-4.071q-8.483,0-11.537,3.563t-3.737,14.084l-.675,14.258Q131.387,59.5,122.9,55.936t-8.489-11.711q0-5.765,4.926-11.544a59.228,59.228,0,0,1,13.068-11.029,99.908,99.908,0,0,1,17.647-9,85.2,85.2,0,0,1,18.67-5.087q25.117,0,40.227,13.235T224.4,55.428l-.682,57.026q0,6.457.508,12.56a41.955,41.955,0,0,0,1.531,9.164l21.725,4.071v10.528l-16.638,6.11c-3.168,1.136-6.11,2.086-8.824,2.881a25.048,25.048,0,0,1-6.792,1.19q-10.518,0-13.576-11.878l-3.73-13.242h5.087q-11.2,12.564-21.551,18.844a40.466,40.466,0,0,1-21.217,6.277m9.164-20.027a31.013,31.013,0,0,0,14.6-3.563,46.389,46.389,0,0,0,13.235-11.036V88.69L159.225,98.877q-8.152,2.035-11.711,6.451a17.238,17.238,0,0,0-3.57,11.2q0,8.493,7.64,15.448a25.628,25.628,0,0,0,17.821,6.959"
            transform="translate(646.538 43.016)"
          />
          <path
            id="Path_378"
            data-name="Path 378"
            class="cls-3"
            style={{ fill: "#161615" }}
            d="M212.643,155.293,152.9,25.286l-15.956-5.094,1.016-12.219H203.82l.675,12.219-21.043,5.094,46.163,103.189Zm86.9-147.32,1.016,12.219-15.949,5.094L226.9,146.469l-27.159,56.344q-7.47,15.612-15.782,22.066a30.446,30.446,0,0,1-19.178,6.451q-8.493,0-13.75-4.071a12.73,12.73,0,0,1-5.261-10.528,14.409,14.409,0,0,1,4.071-9.672q4.081-4.582,12.56-6.959l31.571-9.505-15.615,16.972,37.681-72.641,3.73-6.11L263.9,25.286l-21.043-5.094.675-12.219Z"
            transform="translate(778.482 45.324)"
          />
          <path
            id="Path_379"
            data-name="Path 379"
            class="cls-4"
            style={{ fill: "#9b0058" }}
            d="M206.764,142.783c.154,2.941.328,6.243-5.568,13.182C158.562,206.439,67.084,266.466,26.69,268.592c-16.524.862-25.548-9.706-26.6-29.9C-2.595,187.649,58.4,122.221,97.325,120.176c8.449-.441,15,5.107,15.361,12.086,1.2,22.761-48.316,54.452-87.975,70.522-4.238,10.535-6.631,20.969-6.17,29.786.441,8.443,3.189,18.61,17.874,17.834,31.945-1.678,113.777-56.05,156.337-107.988,3.463-4.231,6.745-4.773,8.951-4.886,4.405-.234,4.947,3.055,5.06,5.254M32.038,188.043c22.995-10.782,65.034-37.66,64.378-50.147-.194-3.67-2.106-5.04-5.04-4.886-17.627.923-43.877,26.972-59.338,55.034m291.1,4.612c.274,5.14-4.813,13.509-6.878,16.2-13.3,20.214-46.217,52.5-69.719,53.737-15.054.789-30.261-8.356-37.734-38.523-30.755,31.437-42.56,44.947-74.4,83.8-3.436,4.6-5.742,9.88-12.346,10.221a5.587,5.587,0,0,1-6.183-5.561c-.174-3.309,1.41-8.175,6.992-13.991l75.542-83.128c7.674-8.135,7.132-11.424,6.858-16.564-.328-6.243-2.814-18.63-5.428-26.223-4.96-17.413-7.045-22.092-6.624-28.008.06-5.889,5.435-8.75,10.207-9,4.037-.207,6.785,2.961,8.7,11.33l9.826,46.979c32.861-33.389,58.356-59.766,63.068-68.115,2.36-4.171,5.722-10.241,12.333-10.588,3.67-.194,5.261,1.932,5.414,4.873s-3.289,7.533-6.771,11.4c-22.246,25.1-31.31,34.786-57.554,60.829-8.757,8.563-13.189,15.421-13.63,20.969a68.8,68.8,0,0,0,2.433,11.29c3.088,9.779,9.586,21.217,20.595,20.642,19.1-1,42.54-24.325,57.694-44.271,5.842-8.035,9.3-12.266,12.239-12.427,3.67-.187,5.234,1.571,5.368,4.138M466.684,121.8c2.58,49.2-70.247,141.765-119.084,144.332-14.325.749-17.353-7.928-21.758-7.694-1.838.094-4,.943-8.162,5.949-15.247,18.108-49.673,70.722-63.63,99.439-3.329,6.8-7.787,12.928-13.3,13.222-4.412.227-9.238-.622-9.532-6.13-.709-13.583,14.927-38.342,33.523-76.872l79.7-165.094c4-7.941,6.691-12.868,11.832-13.135,5.876-.307,8.249,2.881,8.5,7.654.749,14.318-21.324,42.727-57.507,117.895L280.708,296.52C342.526,197.542,417.48,103.4,448.328,101.78c13.951-.735,17.741,8.269,18.356,20.02m-18.77,7.246c-.481-9.178-3.148-10.882-6.818-10.689-16.156.849-101.357,96.27-99.947,123.075.328,6.243,3.516,10.862,10.12,10.515,32.681-1.718,98.4-89.486,96.645-122.9m202.28,31c.154,2.941-2.573,7.132-9.238,13.376-29.111,27.667-104.178,70.635-140.9,72.567-13.59.715-29.973-2.848-31.17-25.608-2.527-48.108,54.338-108.162,98.035-110.455,14.318-.755,21.217,4.405,21.8,15.421,1.25,23.87-40.515,48.891-87.012,67.9-10.809,4.619-15.869,13.349-15.348,23.269.635,12.112,7.052,15.094,19.164,14.458,23.5-1.237,58.971-20.033,85.662-37.64,24.545-16.384,34.051-24.612,43.155-33.563,3.864-3.516,6.745-4.773,8.951-4.886,4.405-.234,6.725,1.858,6.9,5.16M491.43,186.793c35.461-11.8,76.671-40.475,75.876-55.528-.207-4.044-3.3-6.825-9.545-6.5-19.826,1.043-53.556,31.9-66.33,62.025m123.81,44.325c-.08-1.464-.174-3.3,2.627-13.021,5.668-18.342,26.451-71.35,40.909-97.514,5.722-10.241,10.749-12.714,14.786-12.928,3.3-.174,5.582,1.183,5.06,5.261-.04,6.257-16.411,31.049-24.218,50.608-.969,2.627-2.941,7.152-2.787,10.087.1,1.838.889,2.9,2.727,2.8,4.037-.207,12.253-12.052,19.5-21.27,17.667-21.183,58.857-64.211,90.067-65.856,8.082-.421,13.877,4.8,14.378,14.345.561,10.648-9.418,31.056-18.6,31.538-5.508.287-6.818-3.69-6.958-6.263-.381-7.346,4.719-15.341,4.492-19.753-.16-2.935-.969-4.365-4.639-4.171-18.73.983-57.286,37.988-85.762,77.774-12.7,17.6-17.126,24.465-25.374,35.575-10.341,13.429-12.373,16.852-18.616,17.179-2.567.134-7.42-1.083-7.594-4.392m154.592-28.723c-1.156-22.025,17.908-65.742,35.281-92.427,4.773-7.246,9.164-7.848,12.1-8,4.773-.247,7.828,1.8,8.021,5.475.134,2.567-1.183,5.582-3.924,9.405-16.163,21.838-34.078,66.23-33.443,78.342.267,5.14,2.259,7.988,7.032,7.734,9.178-.481,52.3-27.781,87.072-66.8,2.781-3.088,2.8-2.721,4.639-2.821a3.864,3.864,0,0,1,4.251,3.83c.247,4.773-5.241,12.427-11.872,19.4-36.624,38.743-77.714,62.627-90.568,63.3-12.119.635-17.975-5.688-18.59-17.44M824.466,64.768c-.521-9.913,7.406-20.274,18.422-20.849,5.508-.287,10.027,1.685,10.394,8.656.541,10.281-7.019,20.622-16.2,21.1-7.346.388-12.253-1.932-12.62-8.91m210.5,75.114c.154,2.941-2.573,7.132-9.238,13.376-29.111,27.667-104.178,70.642-140.9,72.567-13.583.715-29.973-2.841-31.17-25.608C851.13,152.114,908,92.054,951.692,89.761c14.318-.749,21.223,4.412,21.8,15.428,1.25,23.864-40.515,48.884-87.012,67.895-10.8,4.619-15.869,13.356-15.348,23.269.635,12.119,7.052,15.094,19.171,14.459,23.5-1.237,58.964-20.033,85.655-37.634,24.546-16.39,34.051-24.619,43.155-33.563,3.87-3.516,6.745-4.773,8.951-4.893,4.405-.227,6.725,1.858,6.9,5.16M876.2,166.633c35.461-11.8,76.671-40.481,75.883-55.535-.214-4.037-3.309-6.825-9.552-6.5-19.826,1.043-53.55,31.905-66.33,62.032m129.867,19.338c5.742-23.87,17.126-59.445,39.766-105.187,3.65-7.554,6.664-13.235,12.172-13.529,5.141-.267,9.358,2.828,9.586,7.233.274,5.14-3.81,11.611-5.468,15.013-16.665,33.275-19.292,39.3-36.812,91.4,34.906-43.436,67.072-76.056,93.877-77.46,11.751-.615,12.386,11.5,10.588,26.324l-2.808,23.71c-.969,9.626-2.38,17.8,3.5,17.493,16.156-.849,42.754-27.286,52.3-27.788a4.084,4.084,0,0,1,4.291,4.566c-.581,9.967-53.85,40.381-67.433,41.1-6.243.328-10.4-1.664-10.749-8.275-.187-3.67.682-15.134,2.48-29.953l1.571-12.233c1.544-12.6,1.658-17.393-3.85-17.106-14.318.755-52.219,36.25-70.428,61.136-2.761,3.463-11.711,15.348-15.521,19.96-4.485,5.762-6.571,8.082-12.447,8.389-6.243.328-8.83-6.9-4.612-24.793m150.736,10.14c-2.239-42.594,63.911-136.277,99.526-138.149,13.222-.7,19.479,6.344,20.08,17.727.729,13.951-6.016,32.714-15.562,33.215-5.508.294-7.52-2.914-7.694-6.223-.408-7.707,6.3-13.215,5.9-20.929-.267-5.14-3.068-9.412-7.841-9.158-29.746,1.558-76.237,90.9-74.806,118.068.615,11.751,4.846,15.207,12.921,14.786,20.568-1.083,68.249-25.675,92.808-41.691,23.5-15.227,40.976-26.083,49.425-33.523,4.927-4.311,8.483-6.7,11.056-6.845s4.458.876,4.6,3.443c.154,2.941-1.8,7.828-9.245,13.376-44.278,33.249-113.8,76.665-152.721,78.71-15.789.829-27.614-7.019-28.443-22.807m308.477-22.072c.154,2.935-1.411,8.175-9.238,13.369-36.645,24.385-76.417,38.255-102.126,39.606-24.6,1.29-41.37-9.606-42.567-32.373-2.527-48.1,54.338-108.162,98.035-110.455,10.648-.561,19.385,4.505,19.96,15.521,1.257,23.87-38.677,48.79-85.174,67.8-10.809,4.619-15.869,13.356-15.348,23.269.635,12.119,7.433,22.44,30.568,21.223,23.5-1.237,54.5-13.911,90.04-38.235,4.258-3.168,6.751-4.773,8.951-4.886,4.405-.234,6.724,1.858,6.9,5.16M1334.54,159.547c35.114-11.417,76.016-38.971,75.221-54.024-.207-4.037-3.262-6.09-9.505-5.762-19.458,1.023-52.9,30.394-65.715,59.786m279.225-39.318c.481,9.185-15.963,11.517-26.17,13.529l-43.75,8.189c.267,33.122-37.293,68.229-72.54,70.08-18.362.963-27.674-8.122-28.309-20.234-1.31-24.973,39.8-48.483,78.757-56.792l3.289-.541c-9.7-16.424-43.269-17.607-44.251-36.337-1.718-32.681,42.928-51.959,73.77-53.583,18.362-.963,24.024,1.684,24.412,9.031.4,7.714-4.853,12.774-10.729,13.082-6.243.328-10.9-4.211-25.956-3.422-25.334,1.33-46.865,12.032-46,28.556.769,14.686,36.872,15,45.488,38.85l27.674-5.869c29.125-6.317,33.356-9.853,38.129-10.1,4.405-.234,6.009,2.259,6.183,5.561M1527.8,145l-1.818.461c-30.629,5.662-65.227,26.992-64.4,42.781.234,4.405,3.015,8.309,11.1,7.888,29-1.524,53.864-33.021,55.12-51.13"
            transform="translate(0.001 249.506)"
          />
        </g>
      </g>
    </svg>
  ),
  DayUseLoginPageLogoLong: (
    <svg
      id="Group_1627"
      data-name="Group 1627"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 1927.142 896.91"
    >
      <g
        id="Group_1619"
        data-name="Group 1619"
        class="cls-2"
        style={{ fill: "#161615" }}
      >
        <path
          id="Path_359"
          data-name="Path 359"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M100.334,184.435,97.9,172.921h-.589q-6.063,7.591-12.071,10.3-6.016,2.686-15.023,2.69-12.031,0-18.858-6.2t-6.835-17.641q0-24.5,39.2-25.686l13.726-.454v-5.021c0-6.334-1.361-11.029-4.1-14.052s-7.1-4.551-13.1-4.551q-10.121,0-22.885,6.207L53.6,109.137a58.156,58.156,0,0,1,13.105-5.1A56.96,56.96,0,0,1,80.99,102.2q14.466,0,21.452,6.429,6.97,6.409,6.97,20.585v55.222Zm-27.683-8.641q11.434,0,17.975-6.27t6.533-17.569v-7.3l-12.254.509q-14.621.513-21.078,4.543t-6.453,12.509q0,6.648,4.018,10.113t11.259,3.469"
          transform="translate(309.752 711.003)"
        />
        <path
          id="Path_360"
          data-name="Path 360"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M91.7,191.022a40.314,40.314,0,0,0,6.278-.477,39.407,39.407,0,0,0,4.8-1v9.381a22.381,22.381,0,0,1-5.872,1.583,43.71,43.71,0,0,1-6.978.629q-23.466,0-23.473-24.723V128.281H54.867v-5.9l11.586-5.1,5.172-17.267h7.082v18.747H102.18v9.525H78.707V175.9q0,7.3,3.469,11.22t9.525,3.907"
          transform="translate(381.716 695.774)"
        />
        <path
          id="Path_361"
          data-name="Path 361"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M174.253,206.892H161.848l-21.771-72.267q-1.552-4.8-3.469-12.111a68.946,68.946,0,0,1-2-8.785,167.9,167.9,0,0,1-5.164,21.333l-21.118,71.829h-12.4L67.214,98.97H80.5l17.052,66.657a247.221,247.221,0,0,1,5.164,25.4,183.141,183.141,0,0,1,5.9-26.434L127.967,98.97h13.288l20.3,66.211a200.911,200.911,0,0,1,5.984,25.845,220.085,220.085,0,0,1,5.315-25.55l16.98-66.506h13.28Z"
          transform="translate(467.616 688.546)"
        />
        <path
          id="Path_362"
          data-name="Path 362"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M141.616,184.435l-2.435-11.514h-.589q-6.063,7.591-12.071,10.3-6.016,2.686-15.023,2.69-12.031,0-18.858-6.2t-6.835-17.641q0-24.5,39.2-25.686l13.726-.454v-5.021c0-6.334-1.361-11.029-4.1-14.052s-7.1-4.551-13.1-4.551q-10.121,0-22.885,6.207l-3.772-9.374a58.155,58.155,0,0,1,13.105-5.1,56.961,56.961,0,0,1,14.283-1.838q14.466,0,21.452,6.429,6.97,6.409,6.97,20.585v55.222Zm-27.683-8.641q11.434,0,17.975-6.27t6.533-17.569v-7.3l-12.254.509q-14.621.513-21.078,4.543t-6.453,12.509q0,6.648,4.018,10.113t11.259,3.469"
          transform="translate(596.955 711.003)"
        />
        <path
          id="Path_363"
          data-name="Path 363"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M134.406,102.179a48.1,48.1,0,0,1,9.668.883l-1.695,11.371a41.72,41.72,0,0,0-8.856-1.114q-9.823,0-16.8,7.973t-6.978,19.861v43.414H97.493V103.659h10.114l1.408,14.975h.589a35.441,35.441,0,0,1,10.854-12.174,24.445,24.445,0,0,1,13.949-4.281"
          transform="translate(678.27 710.871)"
        />
        <path
          id="Path_364"
          data-name="Path 364"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M160.977,184.567V132.225q0-9.883-4.5-14.768-4.5-4.87-14.1-4.862-12.7,0-18.6,6.859-5.908,6.875-5.9,22.67v42.443H105.611V103.659h9.962l2,11.076h.589a24.99,24.99,0,0,1,10.559-9.262,34.2,34.2,0,0,1,15.134-3.294q14.609,0,21.993,7.05t7.384,22.558v52.779Z"
          transform="translate(734.748 710.871)"
        />
        <path
          id="Path_365"
          data-name="Path 365"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M155.766,186.039q-17.927,0-28.311-10.925-10.36-10.921-10.368-30.34,0-19.563,9.636-31.08T152.6,102.179q15.194,0,24.062,10t8.856,26.394v7.75H129.786q.37,14.239,7.2,21.627,6.815,7.388,19.224,7.376a65.235,65.235,0,0,0,25.837-5.451V180.8a65.381,65.381,0,0,1-12.286,4.018,69.191,69.191,0,0,1-14,1.217m-3.318-73.6q-9.74,0-15.54,6.358-5.789,6.338-6.827,17.561h42.3q0-11.59-5.172-17.752t-14.76-6.167"
          transform="translate(814.581 710.871)"
        />
        <path
          id="Path_366"
          data-name="Path 366"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M165.586,102.179a48.1,48.1,0,0,1,9.668.883l-1.695,11.371a41.719,41.719,0,0,0-8.856-1.114q-9.823,0-16.8,7.973t-6.978,19.861v43.414H128.673V103.659h10.113l1.408,14.975h.589a35.44,35.44,0,0,1,10.853-12.174,24.445,24.445,0,0,1,13.949-4.281"
          transform="translate(895.193 710.871)"
        />
        <path
          id="Path_367"
          data-name="Path 367"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M224.28,206.892H211.731V156.1H154.886v50.79H142.337V98.97h12.548v45.913h56.846V98.97H224.28Z"
          transform="translate(990.257 688.542)"
        />
        <path
          id="Path_368"
          data-name="Path 368"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M230.28,144.033q0,19.789-9.97,30.9t-27.532,11.108a36.47,36.47,0,0,1-19.272-5.093,33.636,33.636,0,0,1-12.994-14.609q-4.571-9.536-4.575-22.3,0-19.777,9.891-30.818T193.3,102.179q16.972,0,26.983,11.3,10,11.279,10,30.555m-61.644,0q0,15.5,6.2,23.625t18.238,8.124q12.031,0,18.27-8.084t6.238-23.664q0-15.421-6.238-23.434t-18.421-8q-12.031,0-18.158,7.893t-6.127,23.545"
          transform="translate(1084.872 710.871)"
        />
        <path
          id="Path_369"
          data-name="Path 369"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M203.848,191.022a40.313,40.313,0,0,0,6.278-.477,39.4,39.4,0,0,0,4.8-1v9.381a22.379,22.379,0,0,1-5.872,1.583,43.709,43.709,0,0,1-6.978.629q-23.466,0-23.474-24.723V128.281H167.015v-5.9l11.586-5.1,5.172-17.267h7.082v18.747h23.473v9.525H190.855V175.9q0,7.3,3.469,11.22t9.525,3.907"
          transform="translate(1161.943 695.774)"
        />
        <path
          id="Path_370"
          data-name="Path 370"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M213.542,186.039q-17.927,0-28.312-10.925-10.36-10.921-10.368-30.34,0-19.563,9.636-31.08t25.877-11.514q15.194,0,24.062,10t8.856,26.394v7.75H187.561q.37,14.239,7.2,21.627,6.815,7.388,19.224,7.376a65.235,65.235,0,0,0,25.837-5.451V180.8a65.381,65.381,0,0,1-12.286,4.018,69.189,69.189,0,0,1-14,1.217m-3.318-73.6q-9.739,0-15.54,6.358-5.789,6.338-6.827,17.561h42.3q0-11.59-5.172-17.752t-14.76-6.167"
          transform="translate(1216.535 710.871)"
        />
        <rect
          id="Rectangle_1702"
          data-name="Rectangle 1702"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          width="12.254"
          height="114.869"
          transform="translate(1483.596 780.561)"
        />
        <path
          id="Path_371"
          data-name="Path 371"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M248.34,162.494q0,11.279-8.419,17.418-8.415,6.123-23.617,6.127-16.1,0-25.1-5.1V169.584a61.282,61.282,0,0,0,12.517,4.647,52.315,52.315,0,0,0,12.882,1.687q9.585,0,14.761-3.056a10.542,10.542,0,0,0,1.066-17.426q-4.082-3.354-15.978-7.933-11.291-4.2-16.057-7.344a22.037,22.037,0,0,1-7.09-7.122,18.655,18.655,0,0,1-2.316-9.517,18.132,18.132,0,0,1,8.045-15.62q8.045-5.717,22.073-5.721a64.67,64.67,0,0,1,25.542,5.315l-4.36,9.962q-12.174-5.013-22.073-5.021-8.713,0-13.137,2.737a8.439,8.439,0,0,0-4.432,7.528,9.192,9.192,0,0,0,1.663,5.538,16.281,16.281,0,0,0,5.355,4.353,119.854,119.854,0,0,0,14.172,5.984q14.394,5.24,19.455,10.551a18.648,18.648,0,0,1,5.053,13.368"
          transform="translate(1328.705 710.871)"
        />
        <path
          id="Path_372"
          data-name="Path 372"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M76.758,0h97.785q63.844,0,99.607,30.508t35.759,85.459q0,35.568-16.567,62.837T247.279,221.63q-29.5,15.564-67.89,15.556H76.758l-.812-15.349,24.651-5.658q.812-3.64,1.416-20.609t.6-38.791V80.812q0-23.836-.6-40.406t-1.416-19.4l-24.651-5.65Zm61.015,21.818q0,3.64-.2,9.9Q137.359,38,137.168,49.5q-.215,11.506-.207,31.311v75.967q0,12.127.207,22.829.191,10.718.8,19.193t1.011,14.148q12.926,1.611,23.235,2.626t20,1.011q42.825,0,65.057-22.837,22.212-22.821,22.224-66.06,0-26.27-6.469-46.676T243.841,46.867A81.849,81.849,0,0,0,212.729,26.06q-18.393-7.066-42.634-7.066-7.269,0-15.349.6a162.087,162.087,0,0,0-16.972,2.22"
          transform="translate(528.365)"
        />
        <path
          id="Path_373"
          data-name="Path 373"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M169.094,187.78q-16.173,0-28.693-6.461a52.887,52.887,0,0,1-19.59-16.567q-7.078-10.1-7.074-21.015,0-13.726,8.888-22.63,8.88-8.88,29.091-15.349l61.421-20.609V64.54a30.438,30.438,0,0,0-6.063-18.389,42.236,42.236,0,0,0-16.161-13.129,51.688,51.688,0,0,0-22.63-4.846q-10.1,0-13.734,4.241T150.1,49.183l-.8,16.973q-14.55,3.235-24.651-1.011T114.54,51.2q0-6.863,5.864-13.742A70.5,70.5,0,0,1,135.96,24.333a118.924,118.924,0,0,1,21.007-10.71,101.423,101.423,0,0,1,22.224-6.055q29.9,0,47.886,15.755T245.466,64.54l-.812,67.882q0,7.687.6,14.951a49.945,49.945,0,0,0,1.822,10.909l25.861,4.846v12.532l-19.805,7.273c-3.772,1.353-7.273,2.483-10.5,3.43a29.816,29.816,0,0,1-8.084,1.416q-12.521,0-16.161-14.14l-4.44-15.763H220q-13.332,14.955-25.654,22.431a48.169,48.169,0,0,1-25.256,7.472M180,163.94a36.917,36.917,0,0,0,17.378-4.241,55.22,55.22,0,0,0,15.755-13.137V104.135l-45.252,12.127q-9.7,2.423-13.941,7.679t-4.249,13.328q0,10.11,9.1,18.389A30.507,30.507,0,0,0,180,163.94"
          transform="translate(791.274 52.644)"
        />
        <path
          id="Path_374"
          data-name="Path 374"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M227.054,183.34,155.942,28.582l-18.994-6.063,1.21-14.546h78.393l.8,14.546-25.049,6.063,54.952,122.834ZM330.5,7.973l1.21,14.546-18.986,6.063L244.027,172.836,211.7,239.907q-8.892,18.584-18.787,26.266a36.242,36.242,0,0,1-22.829,7.679q-10.109,0-16.368-4.846a15.154,15.154,0,0,1-6.262-12.532q0-6.051,4.846-11.514t14.951-8.283l37.581-11.315-18.588,20.2,44.854-86.47,4.44-7.273L288.07,28.582l-25.049-6.063.8-14.546Z"
          transform="translate(952.763 55.469)"
        />
        <line
          id="Line_97"
          data-name="Line 97"
          class="cls-4"
          height="5px"
          style={{ stroke: "#9b0058", strokeWidth: "1.5px" }}
          x2="1921.739"
          transform="translate(5.4 681.826)"
        />
        <path
          id="Path_375"
          data-name="Path 375"
          class="cls-3"
          style={{ clipPath: "url(#clip-path)" }}
          d="M246.128,161.61c.183,3.5.39,7.432-6.628,15.691C188.749,237.385,79.856,308.84,31.771,311.37,12.1,312.4,1.359,299.817.1,275.778-3.089,215.018,69.52,137.133,115.854,134.7c10.058-.525,17.856,6.079,18.285,14.386,1.424,27.094-57.514,64.819-104.724,83.948-5.045,12.54-7.893,24.961-7.344,35.457.525,10.05,3.8,22.153,21.277,21.23,38.027-2,135.438-66.72,186.1-128.547,4.122-5.037,8.029-5.681,10.655-5.817,5.244-.278,5.888,3.636,6.024,6.254M38.137,215.487c27.372-12.835,77.415-44.83,76.635-59.694-.231-4.369-2.506-6-6-5.817-20.983,1.1-52.23,32.107-70.635,65.511m346.516,5.49c.326,6.119-5.729,16.081-8.188,19.28-15.835,24.062-55.016,62.5-82.993,63.967-17.919.939-36.022-9.946-44.918-45.857-36.611,37.422-50.663,53.5-88.563,99.758-4.09,5.474-6.835,11.761-14.7,12.166a6.651,6.651,0,0,1-7.36-6.62c-.207-3.939,1.679-9.732,8.323-16.654l89.923-98.955c9.135-9.684,8.49-13.6,8.164-19.718-.39-7.432-3.35-22.176-6.461-31.216-5.9-20.728-8.387-26.3-7.886-33.34.072-7.01,6.469-10.416,12.151-10.718,4.806-.247,8.076,3.525,10.352,13.487l11.7,55.923c39.117-39.746,69.466-71.145,75.075-81.083,2.809-4.965,6.811-12.19,14.681-12.6,4.368-.231,6.262,2.3,6.445,5.8s-3.915,8.968-8.061,13.567c-26.481,29.879-37.271,41.409-68.511,72.41-10.424,10.193-15.7,18.357-16.225,24.961a81.9,81.9,0,0,0,2.9,13.44c3.676,11.633,11.411,25.256,24.516,24.572,22.733-1.194,50.639-28.956,68.678-52.7,6.955-9.564,11.068-14.6,14.569-14.792,4.368-.223,6.23,1.87,6.39,4.926m170.879-84.345c3.072,58.572-83.621,168.755-141.756,171.81-17.052.891-20.657-9.437-25.9-9.159-2.188.111-4.766,1.122-9.716,7.082-18.15,21.556-59.129,84.186-75.744,118.37-3.963,8.1-9.27,15.389-15.827,15.739-5.252.271-11-.74-11.347-7.3-.843-16.169,17.768-45.642,39.9-91.507l94.873-196.525c4.766-9.453,7.965-15.317,14.084-15.636,6.994-.366,9.819,3.429,10.121,9.111.891,17.044-25.383,50.862-68.455,140.34L334.15,344.615C407.737,226.794,496.96,114.726,533.682,112.8c16.607-.875,21.118,9.843,21.85,23.832m-22.344,8.626c-.573-10.925-3.748-12.954-8.116-12.723-19.232,1.011-120.654,114.6-118.975,146.506.39,7.432,4.185,12.93,12.047,12.517,38.9-2.045,117.137-106.522,115.044-146.3m240.79,36.905c.183,3.5-3.063,8.49-11,15.922-34.653,32.934-124.012,84.083-167.72,86.382-16.177.851-35.68-3.39-37.1-30.484-3.008-57.267,64.683-128.754,116.7-131.483,17.044-.9,25.256,5.244,25.948,18.357,1.488,28.415-48.228,58.2-103.578,80.828-12.867,5.5-18.89,15.89-18.27,27.7.756,14.418,8.395,17.967,22.813,17.211,27.977-1.472,70.2-23.847,101.97-44.807,29.219-19.5,40.534-29.3,51.371-39.953,4.6-4.185,8.029-5.681,10.655-5.817,5.244-.279,8,2.212,8.212,6.143M584.99,214c42.213-14.052,91.268-48.18,90.321-66.1-.247-4.814-3.931-8.124-11.363-7.734-23.6,1.241-63.752,37.971-78.958,73.834m147.382,52.764c-.1-1.743-.207-3.931,3.127-15.5,6.748-21.834,31.486-84.934,48.7-116.078,6.811-12.19,12.8-15.134,17.6-15.389,3.931-.207,6.644,1.408,6.024,6.262-.048,7.448-19.535,36.961-28.829,60.243-1.154,3.127-3.5,8.514-3.318,12.007.119,2.188,1.058,3.453,3.247,3.334,4.806-.247,14.585-14.347,23.211-25.32,21.031-25.216,70.062-76.436,107.214-78.393,9.62-.5,16.519,5.713,17.116,17.076.668,12.676-11.212,36.969-22.137,37.542-6.557.342-8.116-4.392-8.283-7.456-.454-8.745,5.618-18.262,5.347-23.513-.191-3.493-1.154-5.2-5.522-4.965-22.3,1.17-68.192,45.22-102.09,92.581-15.119,20.951-20.386,29.123-30.205,42.348-12.31,15.986-14.729,20.06-22.161,20.45-3.056.159-8.832-1.289-9.039-5.228M916.4,232.571c-1.377-26.219,21.317-78.258,42-110.023,5.681-8.626,10.909-9.342,14.4-9.525,5.681-.294,9.318,2.14,9.549,6.517.159,3.056-1.408,6.644-4.671,11.2-19.24,26-40.565,78.839-39.81,93.257.318,6.119,2.69,9.509,8.371,9.206,10.925-.573,62.256-33.07,103.649-79.515,3.31-3.676,3.334-3.239,5.522-3.358a4.6,4.6,0,0,1,5.061,4.559c.294,5.681-6.238,14.792-14.132,23.092-43.6,46.119-92.509,74.55-107.811,75.354-14.426.756-21.4-6.771-22.129-20.76M981.429,68.742c-.621-11.8,8.816-24.134,21.93-24.818,6.557-.342,11.936,2.005,12.373,10.3.645,12.238-8.355,24.548-19.28,25.121-8.745.462-14.585-2.3-15.023-10.607M1232,158.156c.183,3.5-3.063,8.49-11,15.922-34.653,32.934-124.011,84.091-167.72,86.382-16.169.851-35.68-3.382-37.1-30.484-3.008-57.259,64.683-128.754,116.7-131.483,17.044-.891,25.264,5.252,25.948,18.365,1.488,28.407-48.228,58.19-103.578,80.82-12.859,5.5-18.89,15.9-18.27,27.7.756,14.426,8.395,17.967,22.821,17.211,27.969-1.472,70.19-23.847,101.963-44.8,29.219-19.511,40.533-29.306,51.371-39.953,4.607-4.185,8.029-5.681,10.655-5.825,5.244-.271,8,2.212,8.212,6.143M1043.009,190c42.213-14.052,91.268-48.188,90.329-66.108-.255-4.806-3.939-8.124-11.371-7.734-23.6,1.241-63.744,37.979-78.958,73.842m154.591,23.02c6.835-28.415,20.386-70.763,47.337-125.213,4.345-8.992,7.933-15.755,14.49-16.105,6.119-.318,11.14,3.366,11.411,8.61.326,6.119-4.536,13.822-6.509,17.872-19.837,39.611-22.964,46.788-43.82,108.806,41.552-51.705,79.842-90.536,111.75-92.207,13.989-.732,14.745,13.686,12.6,31.335l-3.342,28.224c-1.154,11.458-2.833,21.19,4.162,20.824,19.232-1.011,50.894-32.481,62.256-33.078a4.862,4.862,0,0,1,5.108,5.435c-.692,11.864-64.1,48.069-80.271,48.92-7.432.39-12.381-1.981-12.8-9.851-.223-4.368.812-18.015,2.952-35.656l1.87-14.562c1.838-15,1.973-20.7-4.583-20.362-17.044.9-62.161,43.151-83.836,72.776-3.286,4.122-13.941,18.27-18.476,23.76-5.339,6.859-7.822,9.62-14.816,9.986-7.432.39-10.511-8.212-5.49-29.513m179.433,12.071c-2.666-50.7,76.078-162.222,118.473-164.45,15.739-.828,23.187,7.551,23.9,21.1.867,16.607-7.161,38.942-18.524,39.539-6.557.35-8.952-3.469-9.159-7.408-.485-9.175,7.5-15.731,7.018-24.914-.318-6.119-3.652-11.2-9.334-10.9-35.409,1.854-90.751,108.2-89.048,140.546.732,13.989,5.769,18.1,15.381,17.6,24.484-1.289,81.242-30.563,110.477-49.629,27.977-18.126,48.777-31.049,58.835-39.9,5.864-5.132,10.1-7.981,13.161-8.148s5.307,1.042,5.475,4.1c.183,3.5-2.141,9.318-11,15.922-52.708,39.579-135.462,91.26-181.8,93.7-18.795.987-32.871-8.355-33.857-27.15m367.2-26.274c.183,3.493-1.679,9.732-11,15.914-43.621,29.028-90.966,45.539-121.569,47.146-29.282,1.536-49.247-11.442-50.671-38.536-3.008-57.259,64.683-128.754,116.7-131.483,12.676-.668,23.076,5.363,23.76,18.476,1.5,28.415-46.04,58.079-101.39,80.709-12.867,5.5-18.89,15.9-18.27,27.7.756,14.426,8.848,26.712,36.388,25.264,27.977-1.472,64.874-16.559,107.182-45.515,5.068-3.772,8.036-5.681,10.655-5.817,5.244-.279,8.005,2.212,8.212,6.143m-155.625-17.251c41.8-13.591,90.488-46.39,89.541-64.309-.246-4.806-3.883-7.249-11.315-6.859-23.163,1.217-62.973,36.181-78.226,71.168M1921,134.762c.573,10.933-19,13.71-31.152,16.105l-52.079,9.748c.318,39.427-44.393,81.218-86.351,83.422-21.858,1.146-32.942-9.668-33.7-24.086-1.56-29.728,47.377-57.713,93.751-67.6l3.915-.644c-11.546-19.551-51.506-20.959-52.676-43.255-2.045-38.9,51.1-61.851,87.815-63.784,21.858-1.146,28.6,2.005,29.06,10.75.477,9.182-5.777,15.206-12.771,15.572-7.432.39-12.978-5.013-30.9-4.074-30.157,1.583-55.787,14.323-54.753,33.993.915,17.482,43.891,17.856,54.148,46.247l32.942-6.986c34.669-7.519,39.706-11.729,45.387-12.023,5.244-.278,7.153,2.689,7.36,6.62m-102.328,29.481-2.164.549c-36.46,6.74-77.646,32.131-76.659,50.926.279,5.244,3.589,9.891,13.209,9.389,34.526-1.814,64.119-39.308,65.615-60.864"
          transform="translate(0.002 305.362)"
        />
      </g>
    </svg>
  ),
};

export const rightArrowAddOns = (
  <svg
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    width="33.434"
    height="20"
    viewBox="0 0 451.847 451.847"
    style={{
      fill: "#4d5b89",
      enableBackground: "new 0 0 451.847 451.847",
      transform: "rotate(180deg)",
    }}
  >
    <g>
      <path
        d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
		c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
		c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"
      />
    </g>
  </svg>
);

export const check = (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="405.272px"
    height="405.272px"
    viewBox="0 0 405.272 405.272"
    style={{ fill: "rgb(77, 91, 137)" }}
  >
    <g>
      <path
        d="M393.401,124.425L179.603,338.208c-15.832,15.835-41.514,15.835-57.361,0L11.878,227.836
		c-15.838-15.835-15.838-41.52,0-57.358c15.841-15.841,41.521-15.841,57.355-0.006l81.698,81.699L336.037,67.064
		c15.841-15.841,41.523-15.829,57.358,0C409.23,82.902,409.23,108.578,393.401,124.425z"
      />
    </g>
  </svg>
);

export const dayUseCheck = (width, height) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
    style={{fill: "#7B9A61"}}
  >
    <path d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
  </svg>
);
